import React, { useState, useEffect } from 'react';
import Header from '../../assets/header/Header.js';
import Sidebar from '../../assets/sidebar/sidebar.js';
import { useModal } from '../modalPopup/modelcontext.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './deploymentrequest.css';
import { GetAllSBPPartnersDetails } from '../../services/adminServices.js'
import { GetAllResponseEvents, GetAllPositionStatuses, GetSbpPartnerSupportStatus, GetRlaFundingType, GetRlaDocumentType, GetAllGeneralStatus } from '../../services/dropdownServices.js';
import { HandleSendToSbpPartners, UpdateSbpPartnersDetais, ComHodApprovalRequest, UploadCandidatesCv, GetUploadedCandidatesCvs, SelectCandidateRecord, GetSupportedSbpPartners, RLADocumentUpload, RLADocumentApproval, UpdateApprovedDeploymentsDates, SendCheckinSurveyToSelectedCandidate, UploadPerDocument, UploadRLAInvoice, UploadProofOfPayment } from '../../services/deploymentrequestServices.js';
import { GetSbpRequestDetailsById, GetAllHistories, GetAllRemarks, AddRemarkDetails, DownloadUploadedDocument, UpdateCCUsersDetails, ApproveSBPRequest, CandidateSelectionMailNotification, UploadOnboardingDocuments, NotifyRequestersRegardingOnboardingDocs, UpdateCheckinSurvey, SendPerformanceEvaluation, NotifySbpPartnersForRLAInvoice } from '../../services/deploymentrequestServices.js';
import { Modal } from 'react-bootstrap';
import { getToken, userRoles } from '../../services/loginService.js';
import { useParams, useNavigate } from 'react-router-dom';

const ViewSbpDeploymentRequest = () => {
    const navigate = useNavigate();
    const {id} = useParams();
    const roles = userRoles();
    const userInfo = getToken();
    const hasAccess = (requiredRoles) => {
        return roles.some(role => requiredRoles.includes(role.roleName) || requiredRoles.includes(role.roleGroup));
    };
    const [actionDisabled, setActionDisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedDeploymentType, setSelectedDeploymentType] = useState(null);
    const [requestCode, setRequestCode] = useState('');
    const [requestStatus, setRequestStatus] = useState(null);
    const [deploymentRequestId, setDeploymentRequestId] = useState(0);
    const [deploymentRequestPosition, setDeploymentRequestPosition] = useState('');
    const [selectedResponseEvent, setSelectedResponseEvent] = useState('');
    const [ccUsersMail, setCcUsersMail] = useState('');
    const [isCcMailEditing, setIsCcMailEditing] = useState(false);
    const [ccUserEmailIdError, setCcUserEmailIdError] = useState('');
    const [responseEvents, setResponseEvents] = useState([]);
    const [allPositionStatus, setAllPositionStatus] = useState([]);
    const [sbpPartnerSupportStatus, setSbpPartnerSupportStatus] = useState([]);
    const [selectedSupportingTeam, setSelectedSupportingTeam] = useState('');
    const { showModal } = useModal();
    const [show, setShow] = useState(false);
    const [showRemarkModal, setShowRemarkModal] = useState(false);
    const [showSbpPartnersModal, setShowSbpPartnersModal] = useState(false);
    const [remarkPopupText, setRemarkPopupText] = useState('');
    const [remarkError, setRemarkError] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [modalBody, setModalBody] = useState('');
    const [buttonText, setButtonText] = useState('');
    const [reason, setReason] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [isSBP, setIsSBP] = useState(true);
    const [dutyStation, setDutyStation] = useState('');
    const [selectedPositionLevel, setSelectedPositionLevel] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [selectedPositionType, setSelectedPositionType] = useState('');
    const [torDocumentPath, setTorDocumentPath] = useState('');
    const [uploadedDocumentName, setUploadedDocumentName] = useState('');
    const [supervisorName, setSupervisorName] = useState('');
    const [supervisorPosition, setSupervisorPosition] = useState('');
    const [supervisorEmail, setSupervisorEmail] = useState('');
    const [practicalArrangementSupervisorName, setPracticalArrangementSupervisorName] = useState('');
    const [practicalArrangementSupervisorPosition, setPracticalArrangementSupervisorPosition] = useState('');
    const [practicalArrangementSupervisorEmail, setPracticalArrangementSupervisorEmail] = useState('');
    const [performanceEvaluationSupervisorName, setPerformanceEvaluationSupervisorName] = useState('');
    const [performanceEvaluationSupervisorPosition, setPerformanceEvaluationSupervisorPosition] = useState('');
    const [performanceEvaluationSupervisorEmail, setPerformanceEvaluationSupervisorEmail] = useState('');
    const [urgentRequestJustification, setUrgentRequestJustification] = useState('');
    const [criticalRequestJustification, setCriticalRequestJustification] = useState('');
    const [longerTermRequestJustification, setLongerTermRequestJustification] = useState('');
    const [isRequestExtension, setIsRequestExtension] = useState(false);
    const [existingRequestCode, setExistingRequestCode] = useState('');
    const [isOfficeSpaceProvided, setIsOfficeSpaceProvided] = useState(null);
    const [unSecurityPhaseDutyStation, setUnSecurityPhaseDutyStation] = useState('');
    const [specialMedicalRequirements, setSpecialMedicalRequirements] = useState('');
    const [visaRequirements, setVisaRequirements] = useState('');
    const [rrCycle, setRrCycle] = useState('');
    const [errors, setErrors] = useState({});
    const [historyData, setHistoryData] = useState([]);
    const [remarksData, setRemarksData] = useState([]);
    const [showHistory, setShowHistory] = useState(false);
    const [showRemarks, setShowRemarks] = useState(false);
    const [showDeatils, setShowDetails] = useState(true);
    const [deploymentRequestPositionId, setDeploymentRequestPositionId] = useState('');
    const [comHodFullName, setComHodFullName] = useState('');
    const [comHodApprovalDate, setComHodApprovalDate] = useState(null);
    const [comHodApprovalStatus, setComHodApprovalStatus] = useState('');
    const [selectedPostionId, setSelectedPositionId] = useState('');
    const [sbpPartnersList, setSbpPartnersList] = useState([]);
    const [selectedPartners, setSelectedPartners] = useState([]);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [sbpPartnerName, setSbpPartnerName] = useState('');
    const [sendToDate, setSendToDate] = useState(null);
    const [showSbpPartnersNameModal, setShowSbpPartnersNameModal] = useState(false);
    const [sendSbpRequestType, setSendSbpRequestType] = useState('');
    const [proofOfApprovalDocumentPath, setProofOfApprovalDocumentPath] = useState('');
    const [uploadedProofOfApprovalDocumentName, setUploadedProofOfApprovalDocumentName] = useState('');
    const [existingPartnersId, setExistingPartnersId] = useState([]);
    const [sbpPartnersDetails, setSbpPartnersDetails] = useState([]);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [selectedPartnerEdit, setSelectedPartnerEdit] = useState({sbpPartnerName: '', partnerStatusId: '', createdDate: null, rejectedReason: ''});
    const [sbpPartnerUpdateValidation, setSbpPartnerUpdateValidation] = useState(false);
    
    ///Upload CV Section
    const [showUploadCvModal, setShowUploadCvModal] = useState(false);
    const [candidates, setCandidates] = useState([{ deploymentType: "", deploymentRequestId: "", sbpPartnerId: "", supportType: "", candidateName: "", file: null }]);
    const [uploadedCandidateCVs, setUploadedCandidateCVs] = useState([]);
    const [uploadCvError, setUploadCvError] = useState('');
    const [allSupportedSbpPartners, setAllSupportedSbpPartners] = useState([]);
    
    ////Select Candidate Section
    const [showSelectCandidateModal, setShowSelectCandidateModal] = useState(false);
    const [allUploadedCandidates, setAllUploadedCandidates] = useState([]);
    const [selectedCandidateId, setSelectedCandidateId] = useState('');
    const [selectedSupportType, setSelectedSupportType] = useState('');
    const [selectedPartnerName, setSelectedPartnerName] = useState('');
    const [selectedCandidateName, setSelectedCandidateName] = useState('');
    const [candidateEmailId, setCandidateEmailId] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [selectCandidateError, setSelectCandidateError] = useState('');
    const [candidateSelectionRemarkEdit, setCandidateSelectionRemarkEdit] = useState('');
    const [candidateSelectionRemarkView, setCandidateSelectionRemarkView] = useState('');

    ///RLA Document Upload
    const [rlaDocument, setRlaDocument] = useState(null);
    const [rlaFundingType, setRlaFundingType] = useState('');
    const [rlaFundingTypeView, setRlaFundingTypeView] = useState('');
    const [rlaBudget, setRlaBudget] = useState('');
    const [rlaRemarks, setRlaRemarks] = useState('');
    const [uploadedRlaDocumentPath, setUploadedRlaDocumentPath] = useState('');
    const [uploadedRlaDocumentName, setUploadedRlaDocumentName] = useState('');
    const [allFundingTypes, setAllFundingTypes] = useState([]);
    const [rlaSignedDocument, setRlaSignedDocument] = useState(null);
    const [signedRlaDocumentPath, setSignedRlaDocumentPath] = useState('');
    const [signedRlaDocumentName, setSignedRlaDocumentName] = useState('');
    const [rlaWbl, setRlaWbl] = useState('');

    ///Onboarding Document
    const [allDocumentTypes, setAllDocumentTypes] = useState([]);
    const [onboardingDocuments, setOnboardingDocuments] = useState([{ deploymentType: "", deploymentRequestId: "", documentTypeId: "", showOtherDocumentType:"", otherDocumentType: "",  file: null }]);
    const [uploadedOnboardingDocuments, setUploadedOnboardingDocuments] = useState([]);

    ///Actual Start and End Dates
    const [actualFromDate, setActualFromDate] = useState(null);
    const [actualToDate, setActualToDate] = useState(null);
    const [actualFromDateView, setActualFromDateView] = useState(null);
    const [actualToDateView, setActualToDateView] = useState(null);

    ///Send Check-in Survey to Selected Candidate
    const [surveySentDate, setSurveySentDate] = useState(null);
    const [surveyStatus, setSurveyStatus] = useState('');
    const [surveyStatusView, setSurveyStatusView] = useState('');
    const [surveyCompleteDate, setSurveyCompleteDate] = useState(null);
    const [generalStatus, setGeneralStatus] = useState([]);
    const [surveyApplicable, setSurveyApplicable] = useState('');

    ///Performance Evaluation
    const [perDocument, setPerDocument] = useState(null);
    const [uploadedPerDocumentPath, setUploadedPerDocumentPath] = useState('');
    const [uploadedPerDocumentName, setUploadedPerDocumentName] = useState('');
    const [perStatus, setPerStatus] = useState('');
    const [perStatusView, setPerStatusView] = useState('');
    const [perUploadDate, setPerUploadDate] = useState(null);

    ///RLA Invoice Details
    const [rlaInvoiceNotificationSentDate, setRlaInvoiceNotificationSentDate] = useState(null);
    const [rlaInvoice, setRlaInvoice] = useState(null);
    const [rlaInvoiceUploadDate, setRlaInvoiceUploadDate] = useState(null);
    const [rlaInvoiceDocumentName, setRlaInvoiceDocumentName] = useState('');
    const [rlaInvoiceDocumentPath, setRlaInvoiceDocumentPath] = useState('');

    ///Proof of Payment
    const [proofOfPayment, setProofOfPayment] = useState(null);
    const [paymentRemark, setPaymentRemark] = useState('');
    const [proofOfPaymentDocument, setProofOfPaymentDocument] = useState('');
    const [proofOfPaymentDocumentPath, setProofOfPaymentDocumentPath] = useState('');
    const [proofOfPaymentUploadDate, setProofOfPaymentUploadDate] = useState(null);

    const fetchResponseEvents = async() => {
        try{
            GetAllResponseEvents().then((response) =>{
                if(response.status === 200){
                    setResponseEvents(response.data);
                }
            });
        }catch(error){
            console.error('Error while fetching response event dropdownlist details:', error);
        }
    };

    const fetchGeneralStatus = async() => {
        try{
            GetAllGeneralStatus().then((response) =>{
                if(response.status === 200){
                    setGeneralStatus(response.data);
                }
            });
        }catch(error){
            console.error('Error while fetching status dropdownlist details:', error);
        }
    };

    const fetchPositionStatuses = () => {
        try{
            GetAllPositionStatuses().then((response) => {
                if(response.status === 200){
                    setAllPositionStatus(response.data);
                }
            });
        }catch(error){
            console.error('Error while fetching positionStatus detials:', error);
        }
    };

    const fetchFundingTypes = () => {
        try{
            GetRlaFundingType().then((response) => {
                if(response.status === 200){
                    setAllFundingTypes(response.data);
                }
            });
        }catch(error){
            console.error('Error while fetching funding types :', error);
        }
    };

    const fetchDocumentTypes = () => {
        try{
            GetRlaDocumentType().then((response) => {
                if(response.status === 200){
                    setAllDocumentTypes(response.data);
                }
            });
        }catch(error){
            console.error('Error while fetching document types :', error);
        }
    };

    const fetchRequestDetailsById = async (id) => {
        const response = await GetSbpRequestDetailsById(id); 
        if (response.status === 200) {
            return response.data;
        }
    };

    const fetchDeploymentRequestData = async (id) => {
        try {
                const data = await fetchRequestDetailsById(id);
                setDeploymentRequestId(data.deploymentRequestId);
                setDeploymentRequestPosition(data.positionHeader);
                setRequestCode(data.requestCode);
                setRequestStatus(data.status);
                setSelectedDeploymentType(data.deploymentTypeName);
                setSelectedSupportingTeam(data.requestedTeam);
                setSelectedResponseEvent(data.responseId);
                setCcUsersMail(data.ccUserMailIds);
                setIsRequestExtension(data.isExtensionRequest);
                setExistingRequestCode(data.existingRequestCode);
                setDutyStation(data.dutyStation);
                setSelectedPositionLevel(data.selectedPositionLevel);
                setFromDate(data.targetFromDate === '01/01/1970' ? null : data.targetFromDate);
                setToDate(data.targetToDate === '01/01/1970' ? null : data.targetToDate);
                setSelectedPositionType(data.selectedPositionType);
                setUploadedDocumentName(data.uploadedDocumentName);
                setTorDocumentPath(data.torDocumentPath);
                setUrgentRequestJustification(data.urgentRequestJustification);
                setCriticalRequestJustification(data.criticalRequestJustification);
                setLongerTermRequestJustification(data.longerTermRequestJustification);
                setSupervisorName(data.supervisorName);
                setSupervisorPosition(data.supervisorPositionTitle);
                setSupervisorEmail(data.supervisorEmail);
                setPracticalArrangementSupervisorName(data.paSupervisorName);
                setPracticalArrangementSupervisorPosition(data.paSupervisorPositionTitle);
                setPracticalArrangementSupervisorEmail(data.paSupervisorEmail);
                setPerformanceEvaluationSupervisorName(data.peSupervisorName);
                setPerformanceEvaluationSupervisorPosition(data.peSupervisorPositionTitle);
                setPerformanceEvaluationSupervisorEmail(data.peSupervisorEmail);
                setUnSecurityPhaseDutyStation(data.unSecurityPhase);
                setSpecialMedicalRequirements(data.specialMedicalRequirements);
                setVisaRequirements(data.visaRequirement);
                setRrCycle(data.rnRCycle);
                setIsOfficeSpaceProvided(data.isOfficeSpaceProvide);
                setIsSBP(data.deploymentTypeName==='SBP' ? true : false);
                setDeploymentRequestPositionId(data.deploymentRequestPositionId);
                setSelectedPositionId(data.capacityMappingId);
                setSbpPartnerName(data.sbpPartnerName);
                setSendToDate(data.sbpSendToDate);
                setUploadedProofOfApprovalDocumentName(data.uploadedProofOfApprovalDocumentName);
                setProofOfApprovalDocumentPath(data.proofOfApprovalDocumentPath);
                setExistingPartnersId(data.sbpPartnersId);
                setSbpPartnersDetails(data.sbpPartnersDetails);
                setComHodFullName(data.comHodFirstName + ' ' + data.comHodLastName);
                setComHodApprovalDate(data.comHodApprovalDate === '01/01/1970' ? null : data.comHodApprovalDate);
                setComHodApprovalStatus(data.comHodApprovalStatus);
                setUploadedCandidateCVs(data.candidatesUploadedCv);
                setSelectedCandidateName(data.candidateName);
                setCandidateEmailId(data.candidateEmailId);
                setSelectedDate(data.selectedDate === '01/01/1970' ? null : data.selectedDate);
                setSelectedSupportType(data.selectedSupportType);
                setSelectedPartnerName(data.selectedPartnerName);
                setCandidateSelectionRemarkView(data.candidateSelectionRemark);
                setUploadedRlaDocumentName(data.uploadedRlaDocumentName);
                setUploadedRlaDocumentPath(data.uploadedRlaDocumentPath);
                setRlaFundingTypeView(data.rlaFundingType);
                setRlaBudget(data.rlaBudget);
                setRlaRemarks(data.rlaRemarks);
                setSignedRlaDocumentName(data.signedRlaDocumentName);
                setSignedRlaDocumentPath(data.signedRlaDocumentPath);
                setRlaWbl(data.wblText);
                setUploadedOnboardingDocuments(data.uploadedOnboardingDocuments);
                setActualFromDateView(data.actualStartDate === '01/01/1970' ? null : data.actualStartDate);
                setActualToDateView(data.actualEndDate === '01/01/1970' ? null : data.actualEndDate);
                setSurveySentDate(data.surveySentDate === '01/01/1970' ? null : data.surveySentDate);
                setSurveyStatus(data.surveyStatus);
                setSurveyStatusView(data.surveyStatus);
                setSurveyCompleteDate(data.surveyCompleteDate === '01/01/1970' ? null : data.surveyCompleteDate);
                setUploadedPerDocumentName(data.uploadedPerDocumentName);
                setUploadedPerDocumentPath(data.uploadedPerDocumentPath);
                setPerStatus(data.perStatus);
                setPerStatusView(data.perStatus);
                setPerUploadDate(data.perUploadedDate === '01/01/1970' ? null : data.perUploadedDate);
                setRlaInvoiceNotificationSentDate(data.rlaInvoiceNotificationSentDate === '01/01/1970' ? null : data.rlaInvoiceNotificationSentDate);
                setRlaInvoiceUploadDate(data.rlaInvoiceUploadDate === '01/01/1970' ? null : data.rlaInvoiceUploadDate);
                setRlaInvoiceDocumentName(data.rlaInvoiceDocumentName);
                setRlaInvoiceDocumentPath(data.rlaInvoiceDocumentPath);
                setPaymentRemark(data.paymentRemark);
                setProofOfPaymentDocument(data.proofOfPaymentDocumentName);
                setProofOfPaymentDocumentPath(data.proofOfPaymentDocumentPath);
                setProofOfPaymentUploadDate(data.paymentDate);
            } catch (error) {
        }
    };

    const fetchSbpPartnersSupportStatuses = () => {
        try{
            GetSbpPartnerSupportStatus().then((response) => {
                if(response.status === 200){
                    setSbpPartnerSupportStatus(response.data);
                }
            });
        }catch(error){
            console.error('Error while fetching positionStatus detials:', error);
        }
    };

    const fetchUploadedCandidates = async(id) => {
        const response = await GetUploadedCandidatesCvs(id); 
        if (response.status === 200) {
            setAllUploadedCandidates(response.data);
        }
    };

    const fetchSupportedSbpPartners = async(id) => {
        const response = await GetSupportedSbpPartners(id); 
        if (response.status === 200) {
            setAllSupportedSbpPartners(response.data);
        }
    };

    useEffect(() => {
        fetchResponseEvents();
        fetchGeneralStatus();
        fetchPositionStatuses();
        fetchSbpPartnersList();
        fetchDocumentTypes();
        fetchFundingTypes();
        fetchSbpPartnersSupportStatuses();
        if (id) {
            const numericId = parseInt(id, 10);
            if (!isNaN(numericId)) {
                fetchDeploymentRequestData(numericId);
            }
        }
    }, [id]);

    const formatDate = (isoString) => {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0'); // Pad with leading zero
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const validateEmails = (emails) => {
        const emailArray = emails.split(",").map((email) => email.trim());
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
        for (let email of emailArray) {
          if (!emailRegex.test(email)) {
            return `Invalid Cc User emailId: ${email}`;
          }
        }
        return null;
    }; 

    const handleDownloadDocument = async (documentName, documentPath) => {
        if (!documentName || !documentPath) {
            showModal('failure', "Document details are missing.");
            return;
        }
        try {
            const response = await DownloadUploadedDocument(documentName, documentPath);
            if (response.success !== false) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const contentDisposition = response.headers['content-disposition'];
                let fileName = documentName; 
                if (contentDisposition && contentDisposition.indexOf('filename=') !== -1) {
                    fileName = contentDisposition.split('filename=')[1].replace(/"/g, ''); 
                }
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                link.click();
                window.URL.revokeObjectURL(url);
                } else {
                    showModal('failure', response.message || "Failed to download the document.");
                }
        } catch (error) {
            showModal('failure', "An unexpected error occurred while downloading the file.");
        }
    };

    const handleEditCcUsersClick = () => {
            setIsCcMailEditing(true);
    };
        
    const handleSaveCcUsersClick = () => {        
        if (ccUsersMail.trim() === '') {
            setCcUserEmailIdError('Cc Emails can not be empty');
            return;
        }
        const validationErrorMessage = validateEmails(ccUsersMail);
        if(validationErrorMessage){
            setCcUserEmailIdError(validationErrorMessage);
            return;
        }
        var payload = {deploymentRequestId: parseInt(deploymentRequestId), ccUsersEmailId: ccUsersMail.trim()};
            UpdateCCUsersDetails(payload).then((res) => {
            if (res.data.success) {
                setIsCcMailEditing(false);
                showModal('success',res.data.message);
                fetchDeploymentRequestData(deploymentRequestId);
                } else {
                showModal('failure',res.data.message);
            }       
        });
    };

    const calculateDaysInclusive = (startDate, endDate) => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        const timeDifference = end - start;
        const daysDifference = timeDifference / (1000 * 3600 * 24);
        return daysDifference + 1;
    };
    
    const handleOpenPopup = () => {
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    const handleInputChange = (e, setter, field) => {        
        if(field === 'actualFromDate' || field === 'actualToDate' || field === 'surveyCompleteDate' || field === 'perUploadDate'){
            setter(e);
        }else if(field === 'rlaDocument' || field === 'rlaSignedDocument' || field === 'perDocument' || field === 'rlaInvoice' || field === 'proofOfPayment'){
            setter(e.target.files[0]);
        }else{
            if(field === 'selectedCandidateId'){
                setCandidateEmailId('');
                setSelectCandidateError('');
            }
            if(field === 'candidateEmailId'){
                setSelectCandidateError(''); 
            }
            const { value } = e.target;
            setter(value);
        }             
    };
    
    function formatDateToUTC(dateString) {
        const date = new Date(dateString);
        
        const formattedDate = date.toLocaleString("en-US", {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: false,        // 12-hour format
          timeZone: 'UTC'      // Convert to UTC time
        });
        return formattedDate;
    };
    
    const fetchHistoryData = async (deploymentRequestId) => {
        try{
            GetAllHistories(deploymentRequestId).then((response) =>{
                if(response.status === 200){
                    setHistoryData(response.data);
                }
            });
        }catch(error){
            console.error('Error while fetching History details:', error);
        }
    };
      
    const fetchRemarksData = async (deploymentRequestId) => {
        try{
            GetAllRemarks(deploymentRequestId).then((response) =>{
                if(response.status === 200){
                    setRemarksData(response.data);
                }
            });
        }catch(error){
            console.error('Error while fetching remarks details:', error);
        }
    };
    
    const handleShowHistory = () =>{
        fetchHistoryData(deploymentRequestId);
        setShowHistory(true);
        setShowDetails(false);
        setShowRemarks(false);
    }; 

    const handleShowRemarks = () => {
        fetchRemarksData(deploymentRequestId);
        setShowRemarks(true)
        setShowHistory(false);
        setShowDetails(false);
    };

    const handleBackToDetails = () => {
        setShowRemarks(false)
        setShowHistory(false);
        setShowDetails(true);
    };
    
    const handleAddRemarkModel = () =>{
        setShowRemarkModal(true);
    };

    const handleCloseRemarkModal = () => {
        setShowRemarkModal(false);
        setRemarkPopupText('');
        setRemarkError('');
    };
    
    const handleRemarkPopupText = (event) => {
        setRemarkPopupText(event.target.value);
    };

    const handleModalConfirmRemark = () => {
        if (remarkPopupText.trim() === '') {
            setRemarkError('Remark cannot be empty');
            return;
        }
        var payload = {deploymentRequestId: parseInt(deploymentRequestId), remarkText: remarkPopupText, requestCode: requestCode, requestedTeam: selectedSupportingTeam};
            AddRemarkDetails(payload).then((res) => {
               if (res.data.success) {
                showModal('success',res.data.message);
                handleCloseRemarkModal();
                fetchRemarksData(deploymentRequestId);
              } else {
                showModal('failure',res.data.message);
                handleCloseRemarkModal();
            }       
        });
    };

    const handleClose = () => {
            setShow(false);
            setReason('');
    };
    
    const openModal = (title, body, btnText) => {
            setModalTitle(title);
            setModalBody(body);
            setButtonText(btnText);
            setShow(true);
    };
    
    const handleModalConfirm = async () => {
        try {
            if(isSBP){
                setActionDisabled(true);
                setLoading(true);
                if(reason==='' && (buttonText !== 'Approve' && buttonText !== 'Launch' && buttonText !== "Save" && buttonText !== "Update" && buttonText !== 'Send' && buttonText !== "Send To Requester" && buttonText !== 'Approve RLA' && buttonText !== 'Update Deployment Dates' && buttonText !== 'Send Check-in Survey' && buttonText !== 'Performance Evaluation' && buttonText !== 'Update Check-in Survey' && buttonText !== 'Upload PER Document' && buttonText !== 'Notify SBP Partner' && buttonText !== 'Upload Invoice' && buttonText !== 'Upload Proof of Payment')){
                    handleClose();
                    setActionDisabled(false);
                    setLoading(false);
                    showModal('failure','Reason is required, Please provide a reason');                    
                    return;
                }
                else if(buttonText === 'Launch' || buttonText === 'Reject' || buttonText === 'Resubmit' || buttonText === 'Revert') {
                    handleClose();
                    setActionDisabled(false);
                    setLoading(false);
                    const formData = createFormDataRequest(buttonText);
                    ApproveSBPRequest(formData).then((res) => {
                        if (res.data.success) {
                            showModal('success', res.data.message);
                            fetchDeploymentRequestData(parseInt(deploymentRequestId));
                        } else {
                            showModal('failure', res.data.message);
                        }
                    });
                }
                else if(buttonText === 'Approve' || buttonText === 'COM Reject'){
                    handleClose();
                    setActionDisabled(false);
                    setLoading(false);
                    const formData = createFormDataRequest(buttonText);
                    ComHodApprovalRequest(formData).then((res) => {
                        if (res.data.success) {
                            showModal('success', res.data.message);
                            fetchDeploymentRequestData(parseInt(deploymentRequestId));
                        } else {
                            showModal('failure', res.data.message);
                        }
                    });
                }
                else if(buttonText === 'Send'){
                    handleClose();
                    setActionDisabled(false);
                    setLoading(false);
                    const formData = sendNotificationRequest();
                    CandidateSelectionMailNotification(formData).then((res) => {
                        if (res.data.success) {
                            showModal('success', res.data.message);
                            fetchDeploymentRequestData(parseInt(deploymentRequestId));
                        } else {
                            showModal('failure', res.data.message);
                        }
                    });
                }
                else if(buttonText === 'Send To Requester'){
                    handleClose();
                    setActionDisabled(false);
                    setLoading(false);
                    const formData = sendRlaDraftDocumentToRequesters();
                    RLADocumentUpload(formData).then((res) => {
                        if (res.data.success) {
                            showModal('success', res.data.message);
                            fetchDeploymentRequestData(parseInt(deploymentRequestId));
                        } else {
                            showModal('failure', res.data.message);
                        }
                    });
                }
                else if(buttonText === 'Approve RLA'){
                    handleClose();
                    setActionDisabled(false);
                    setLoading(false);
                    const formData = sendRlaApprovalDetails();
                    RLADocumentApproval(formData).then((res) => { 
                        if (res.data.success) {
                            showModal('success', res.data.message);
                            fetchDeploymentRequestData(parseInt(deploymentRequestId));
                        } else {
                            showModal('failure', res.data.message);
                        }
                    });
                }
                else if(buttonText === 'Update Deployment Dates'){
                    handleClose();
                    setActionDisabled(false);
                    setLoading(false);
                    var payload = {
                        deploymentRequestId : parseInt(deploymentRequestId),
                        positionId : parseInt(deploymentRequestPositionId),
                        actualStartDate : actualFromDate ? new Date(actualFromDate).toISOString() : null,
                        actualEndDate : actualToDate ? new Date(actualToDate).toISOString() : null,
                        positionHeader : deploymentRequestPosition,
                        dutyStation : dutyStation,
                        deploymentTypeName : selectedDeploymentType,
                        requestedTeam : selectedSupportingTeam,
                        requestCode : requestCode
                    };
                    UpdateApprovedDeploymentsDates(payload).then((res) => { 
                        if (res.data.success) {
                            showModal('success', res.data.message);
                            fetchDeploymentRequestData(parseInt(deploymentRequestId));
                        } else {
                            showModal('failure', res.data.message);
                        }
                    });
                }
                else if(buttonText === 'Send Check-in Survey'){
                    if(!surveyApplicable){
                        handleClose();
                        setActionDisabled(false);
                        setLoading(false);
                        showModal('failure','Survey Applicable is required');                    
                        return;
                    }
                    handleClose();
                    setActionDisabled(false);
                    setLoading(false);
                    var payload = {
                        deploymentRequestId : parseInt(deploymentRequestId),
                        candidateName : selectedCandidateName,
                        candidateEmailId : candidateEmailId,
                        requestCode : requestCode,
                        surveyApplicable : generalStatus.find(res=> res.statusId===parseInt(surveyApplicable))?.statusDescription 
                    };
                    SendCheckinSurveyToSelectedCandidate(payload).then((res) => { 
                        if (res.data.success) {
                            showModal('success', res.data.message);
                            fetchDeploymentRequestData(parseInt(deploymentRequestId));
                        } else {
                            showModal('failure', res.data.message);
                        }
                    });
                }
                else if(buttonText === 'Update Check-in Survey'){
                    handleClose();
                    setActionDisabled(false);
                    setLoading(false);
                    var payload = {
                        deploymentRequestId : parseInt(deploymentRequestId),
                        surveyStatusId : parseInt(surveyStatus),
                        surveyCompleteDate : surveyCompleteDate ? new Date(surveyCompleteDate).toISOString() : null,
                    };
                    UpdateCheckinSurvey(payload).then((res) => { 
                        if (res.data.success) {
                            showModal('success', res.data.message);
                            fetchDeploymentRequestData(parseInt(deploymentRequestId));
                        } else {
                            showModal('failure', res.data.message);
                        }
                    });
                }
                else if (buttonText === 'Performance Evaluation'){
                    handleClose();
                    setActionDisabled(false);
                    setLoading(false);
                    const formData = new FormData();
                    formData.append("deploymentRequestId", parseInt(deploymentRequestId));
                    formData.append("buttonText", buttonText);
                    formData.append('deploymentTypeText', selectedDeploymentType);
                    formData.append('requestedTeamName',selectedSupportingTeam);
                    formData.append('requestCode', requestCode);
                    formData.append('postionHeader', deploymentRequestPosition);
                    formData.append('dutyStation', dutyStation);
                    await SendPerformanceEvaluation(formData).then((res) => { 
                        if (res.data.success) {
                            showModal('success', res.data.message);
                            fetchDeploymentRequestData(parseInt(deploymentRequestId));
                        } else {
                            showModal('failure', res.data.message);
                        }
                    });
                }
                else if (buttonText === 'Upload PER Document'){
                    handleClose();
                    setActionDisabled(false);
                    setLoading(false);
                    const formData = new FormData();
                    formData.append("deploymentRequestId", parseInt(deploymentRequestId));
                    formData.append("perDocument", perDocument);
                    formData.append('perStatusId', parseInt(perStatus));
                    formData.append('perUploadDate', perUploadDate ? new Date(perUploadDate).toISOString() : null);
                    UploadPerDocument(formData).then((res) => { 
                        if (res.data.success) {
                            showModal('success', res.data.message);
                            fetchDeploymentRequestData(parseInt(deploymentRequestId));
                        } else {
                            showModal('failure', res.data.message);
                        }
                    });
                }
                else if (buttonText === 'Notify SBP Partner'){
                handleClose();
                setActionDisabled(false);
                setLoading(false);
                const formData = new FormData();
                    formData.append("deploymentRequestId", parseInt(deploymentRequestId));
                    formData.append('requestCode', requestCode);
                    formData.append('postionHeader', deploymentRequestPosition);
                    formData.append('dutyStation', dutyStation);
                    formData.append('sbpPartnerName', selectedPartnerName);
                    formData.append('candidateName', selectedCandidateName);
                    NotifySbpPartnersForRLAInvoice(formData).then((res) => { 
                        if (res.data.success) {
                            showModal('success', res.data.message);
                            fetchDeploymentRequestData(parseInt(deploymentRequestId));
                        } else {
                            showModal('failure', res.data.message);
                        }
                    });
                }
                else if (buttonText === 'Upload Invoice'){
                    handleClose();
                    setActionDisabled(false);
                    setLoading(false);
                    const formData = new FormData();
                    formData.append('deploymentRequestId', parseInt(deploymentRequestId));
                    formData.append('requestCode', requestCode);
                    formData.append('postionHeader', deploymentRequestPosition);
                    formData.append('dutyStation', dutyStation);
                    formData.append('deploymentTypeText', selectedDeploymentType);
                    formData.append('rlaInvoice', rlaInvoice);
                    formData.append('candidateName', selectedCandidateName);
                    UploadRLAInvoice(formData).then((res) => { 
                        if (res.data.success) {
                            showModal('success', res.data.message);
                            fetchDeploymentRequestData(parseInt(deploymentRequestId));
                        } else {
                            showModal('failure', res.data.message);
                        }
                    });
                }
                else if (buttonText === 'Upload Proof of Payment'){
                    handleClose();
                    setActionDisabled(false);
                    setLoading(false);
                    const formData = new FormData();
                    formData.append('deploymentRequestId', parseInt(deploymentRequestId));
                    formData.append('requestCode', requestCode);
                    formData.append('postionHeader', deploymentRequestPosition);
                    formData.append('dutyStation', dutyStation);
                    formData.append('deploymentTypeText', selectedDeploymentType);
                    formData.append('proofOfPayment', proofOfPayment);
                    formData.append('paymentRemark', paymentRemark);
                    UploadProofOfPayment(formData).then((res) => { 
                        if (res.data.success) {
                            showModal('success', res.data.message);
                            fetchDeploymentRequestData(parseInt(deploymentRequestId));
                        } else {
                            showModal('failure', res.data.message);
                        }
                    });
                }
            }            
        } catch (error) {
            handleClose(); 
            setActionDisabled(false);
            setLoading(false);
            showModal('failure', 'Request '+ buttonText +' failed with error ' + error);
        }
    };

    function createFormDataRequest(buttonText) {
        const formData = new FormData();
        formData.append('deploymentRequestId', deploymentRequestId);
        formData.append('responseId', parseInt(selectedResponseEvent, 10));
        formData.append('buttonText', buttonText);
        formData.append('remarks', reason);
        formData.append('deploymentTypeText', selectedDeploymentType);
        formData.append('requestedTeamName',selectedSupportingTeam);
        formData.append('requestCode', requestCode);
        formData.append('deploymentRequestPositionId', deploymentRequestPositionId);
        formData.append('capacityMappingId', parseInt(selectedPostionId ?? 0));
        formData.append('postionHeader', deploymentRequestPosition);
        formData.append('dutyStation', dutyStation);
        formData.append('positionStatusId', buttonText ==='Approve' ? pendingStatusId : buttonText==='COM Reject' ? rejectStatusId : buttonText==='Launch' ? approveStatusId : buttonText==='Reject' ? rejectStatusId : buttonText ==='Revert' ? pendingStatusId : buttonText ==='Resubmit'? pendingStatusId : 0);
        return formData;
    };

    function sendNotificationRequest() {
        const formData = new FormData();
        formData.append('deploymentRequestId', deploymentRequestId);
        formData.append('buttonText', "Send");
        formData.append('remarks', candidateSelectionRemarkEdit);
        formData.append('deploymentTypeText', selectedDeploymentType);
        formData.append('requestedTeamName',selectedSupportingTeam);
        formData.append('requestCode', requestCode);
        formData.append('deploymentRequestPositionId', deploymentRequestPositionId);
        formData.append('postionHeader', deploymentRequestPosition);
        formData.append('dutyStation', dutyStation);
        return formData;
    };

    function sendRlaDraftDocumentToRequesters() {
        const formData = new FormData();
        formData.append('deploymentRequestId', deploymentRequestId);
        formData.append('buttonText', "Send To Requester");
        formData.append('rlaUploadedFile', rlaDocument);
        formData.append('rlaFundingTypeId', parseInt(rlaFundingType));
        formData.append('rlaBudget', parseFloat(rlaBudget));
        formData.append('rlaRemarks', rlaRemarks);
        formData.append('deploymentTypeText', selectedDeploymentType);
        formData.append('requestedTeamName',selectedSupportingTeam);
        formData.append('requestCode', requestCode);
        formData.append('postionHeader', deploymentRequestPosition);
        formData.append('dutyStation', dutyStation);
        return formData;
    };

    function sendRlaApprovalDetails() {
        const formData = new FormData();
        formData.append('deploymentRequestId', deploymentRequestId);
        formData.append('buttonText', "Approve RLA");
        formData.append('rlaSignedFile', rlaSignedDocument);
        formData.append('rlaWbl', rlaWbl);
        formData.append('deploymentTypeText', selectedDeploymentType);
        formData.append('requestedTeamName',selectedSupportingTeam);
        formData.append('requestCode', requestCode);
        formData.append('postionHeader', deploymentRequestPosition);
        formData.append('dutyStation', dutyStation);
        return formData;
    };

    const handleReasonChange = (event) => {
        setReason(event.target.value);
    };

    const approveStatusId = allPositionStatus.find(item => item.statusDescription === 'Launched')?.positionStatusId;
    const rejectStatusId = allPositionStatus.find(item => item.statusDescription === 'Rejected')?.positionStatusId;
    const pendingStatusId = allPositionStatus.find(item => item.statusDescription === 'Pending')?.positionStatusId;
    const completeStatusId = generalStatus.find(item => item.statusDescription === 'Completed')?.statusId;
    const generalPendingStatusId = generalStatus.find(item => item.statusDescription === 'Pending')?.statusId;
    const userHasApproveSBPRequest = hasAccess([process.env.REACT_APP_ROLENAME_APPROVEREQUESTSBP]);
    const userHasReviewSBPRequest = hasAccess([process.env.REACT_APP_ROLENAME_REVIEWREQUESTSBP]);
    const userHasSendToSBPAgencies = hasAccess([process.env.REACT_APP_ROLENAME_SENDTOSBPAGENCIES]);
    const userHasComApprover = hasAccess([process.env.REACT_APP_ROLENAME_COMAPPROVER]);
    const userHasUploadCvs = hasAccess([process.env.REACT_APP_ROLENAME_UPLOADCVS]);
    const userHasSelectCandidate = hasAccess([process.env.REACT_APP_ROLENAME_SELECTCANDIDATE]);
    const userHasRLACoordinator = hasAccess([process.env.REACT_APP_ROLENAME_RLACOORDINATOR]);
    const userHasRLAApproval = hasAccess([process.env.REACT_APP_ROLENAME_SIGNRLAAGREEMENT]);
    const userHasSendCheckinSurvey = hasAccess([process.env.REACT_APP_ROLENAME_SENDCHECKINSURVEY]);
    const userHasSendPerformanceEvaluation = hasAccess([process.env.REACT_APP_ROLENAME_SENDPERFORMANCEEVALUATION]);
    const comHodApproveButtonVisibilityStatus = ["Submitted for COM/HOD Approval"]
    const responseEventsVisibilityStatus = ['Submitted for Approval','Launched','In Progress','Completed'];
    const sendSBPPartnersButtonVisibilityStatus = ['Launched']
    const approveButtonVisibilityStatus = ['Submitted','Submitted for Approval'];
    const rejectButtonVisibilityStatus = ['Submitted','Submitted for Approval','Reverted','Launched','SBP Partner Coordination','Candidate Selection','Candidate Selected','Ongoing Deployment'];
    const revertButtonVisibilityStatus = ['Submitted','Launched','Submitted for Approval'];
    const uploadCvButtonVisibilityStatus = ['Supported','Supported on RLA']
    const uploadCvButtonStatus = ['SBP Partner Coordination','Candidate Selection']
    const selectCandidateButtonVisibilityStatus = ['Candidate Selection']
    const rlaSelectedCandidateVisibilityStatus = ['Candidate Selected','Ongoing Deployment'];
    const hasValidCVs = uploadedCandidateCVs?.some(cv => cv.candidateName && cv.uploadedDocumentName && cv.uploadedDocumentPath && cv.uploadedDate);
    const shouldShowUploadButton = sbpPartnersDetails.some(partner => uploadCvButtonVisibilityStatus.includes(partner.sbpPartnerStatus));

    const handleComHodApprove = () => {
        openModal(
            'Confirm Approve',
            <>
            Are you sure you want to Approve this Request?.
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Approve'
            );
    };

    const handleComHodReject = () => {
        openModal(
            'Confirm Rejection',
            <>
            Are you sure you want to reject this Request? Please provide reason for Rejection. 
            <span style={{ color: 'red' }}>*</span>
            </>,
            'COM Reject'
        );
    };

    const handleApprove = () =>{
        openModal(
        'Confirm Launch',
        <>
        Are you sure you want to Launch this Request?.
        <span style={{ color: 'red' }}>*</span>
        </>,
        'Launch'
        );
    }

    const handleSendToSbpPartners = (requestType) => {
        setShowSbpPartnersModal(true);
        setSendSbpRequestType(requestType);
    };

    const handleReject = () => {
        openModal(
            'Confirm Rejection',
            <>
            Are you sure you want to reject this Request? Please provide reason for Rejection. 
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Reject'
        );
    };

    const handleReSubmit = () => {
        openModal(
            'Confirm Re Submit',
            <>
            Are you sure you want to re submit this Request? Please provide reason for Re Submit.',
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Resubmit'
        );
    };

    const handleRevert = () => {
        openModal(
            'Confirm Revert',
            <>
            Are you sure you want to revert this Request? Please provide a reason for Revert.
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Revert'
        );
    };

    const handleReopen = () => {
        navigate(`/sbpdeploymentrequest/edit/${deploymentRequestId}`);
    }

    const fetchSbpPartnersList = async() => {
        try{
            GetAllSBPPartnersDetails().then((response) =>{
                if(response.status === 200){
                    setSbpPartnersList(response.data);
                }
            });
        }catch(error){
            console.error('Error while fetching sbpPartners List:', error);
        }
    };

    const handleCloseSbpPartnersModal = () =>{
        setShowSbpPartnersModal(false);
        setSelectedPartners([]);
        setSendSbpRequestType('');
    };

    const handleSelectAllPartners = () => {
        const selectableIds = sbpPartnersList
          .filter((partner) => !existingPartnersId.includes(partner.sbpId))
          .map((partner) => partner.sbpId);
      
        if (selectedPartners.filter((id) => !existingPartnersId.includes(id)).length === selectableIds.length) {
            setSelectedPartners((prev) => prev.filter((id) => existingPartnersId.includes(id)));
        } else {
            setSelectedPartners([...existingPartnersId, ...selectableIds]);
        }
    };
      
    const handlePartnerSelection = (sbpId) => {
        if (selectedPartners.includes(sbpId)) {
            // If the partner is already selected, remove it
            setSelectedPartners(selectedPartners.filter(id => id !== sbpId));
        } else {
            // Otherwise, add it to the selected list
            setSelectedPartners([...selectedPartners, sbpId]);
        }
    };
    
    const handleOpenConfirmationModal = () => {
        setShowConfirmationModal(true);
    };

    const handleCloseConfirmationModal = () => {
        setShowConfirmationModal(false);
    };

    const handleSendEmailConfirmed = () => {
        setShowConfirmationModal(false);
        setShowSbpPartnersModal(false);
        setSelectedPartners([]);
        var payload = {
            deploymentRequestId : deploymentRequestId,
            remarks : sendSbpRequestType,
            deploymentTypeName : selectedDeploymentType,
            requestedTeam : selectedSupportingTeam,
            requestCode : requestCode,
            positionHeader : deploymentRequestPosition,
            dutyStation : dutyStation,
            sbpPartnersId : selectedPartners,
            deploymentRequestPositionId : deploymentRequestPositionId,
            uploadedDocumentName : uploadedDocumentName,
            torDocumentPath : torDocumentPath,
            grade : selectedPositionLevel,
            duration : formatDate(fromDate) + ' To ' + formatDate(toDate)
        };
        HandleSendToSbpPartners(payload).then((res) => {
            setShowConfirmationModal(false);
            handleClose(); 
            if (res.data.success) {
                showModal('success', res.data.message);
                fetchDeploymentRequestData(parseInt(deploymentRequestId));
            } else {
                showModal('failure', res.data.message);
            }
        });
    };   

    const handleCloseSbpPartnersNameModal = () => {
        setShowSbpPartnersNameModal(false);
    };

    const handleShowSbpPartnersNameModal = () => {
        setShowSbpPartnersNameModal(true);
    };

    const handleUpdatePartnerDetailsClick = (partner) =>{
        setSelectedPartnerEdit(partner);
        setShowUpdateModal(true);
    };
    
    const handleCloseUpdateModal = () => setShowUpdateModal(false);

    const sbpRejectedStatusId = sbpPartnerSupportStatus.find(item => item.statusDescription === 'Rejected')?.partnerStatusId;

    const handleUpdateSbpDetails = () => {
        if (!selectedPartnerEdit.sbpPartnerName || !selectedPartnerEdit.partnerStatusId || !selectedPartnerEdit.createdDate) {
            setSbpPartnerUpdateValidation(true);
            return;
        }
        if(selectedPartnerEdit.partnerStatusId && (parseInt(selectedPartnerEdit.partnerStatusId) === sbpRejectedStatusId) && !selectedPartnerEdit.rejectedReason){
            setSbpPartnerUpdateValidation(true);
            return;
        }
        // Prepare data for update
        const updatedPartnerData = {
            sbpPartnerId: parseInt(selectedPartnerEdit.sbpPartnerId),
            deploymentRequestId : deploymentRequestId,
            partnerStatusId: parseInt(selectedPartnerEdit.partnerStatusId),
            createdDate: selectedPartnerEdit.createdDate ? new Date(selectedPartnerEdit.createdDate).toISOString() : null,
            rejectedReason: selectedPartnerEdit.rejectedReason,
        };
        UpdateSbpPartnersDetais(updatedPartnerData).then((res) => {
            handleClose();
            setShowSbpPartnersNameModal(false);
            setShowUpdateModal(false); 
            if (res.data.success) {
                showModal('success', res.data.message);
                fetchDeploymentRequestData(parseInt(deploymentRequestId));
            } else {
                showModal('failure', res.data.message);
            }
        });
    };    

    const handlePartnerChange = (name, value) => {
        setSbpPartnerUpdateValidation(false);
        setSelectedPartnerEdit((prev) => {
            const updatedState = { ...prev, [name]: value };
    
            // If the status is not "Rejected," reset the rejectedReason
            if (name === "partnerStatusId" && value !== sbpRejectedStatusId) {
                updatedState.rejectedReason = "";
            }    
            return updatedState;
        });
    };
    
    ///Section for Upload Candidate
    const handleUploadCvInputChange = (index, event) => {
        const { name, value, files } = event.target;
        const newCandidates = [...candidates];
        if (name === "sbpPartnerId") {
            const selectedPartner = allSupportedSbpPartners.find(prt => prt.sbpPartnerId === parseInt(value));
            newCandidates[index]["sbpPartnerId"] = parseInt(value);
            newCandidates[index]["supportType"] = selectedPartner ? selectedPartner.supportedType : "";
        } else {
            newCandidates[index][name] = files ? files[0] : value;
        }  
        setCandidates(newCandidates);
        setUploadCvError('');
    };    
    
    const addRow = () => {
        setCandidates([...candidates, { deploymentType: "", deploymentRequestId: "", candidateName: "", file: null  }]);
    };
    
    const removeRow = (index) => {
        const newCandidates = candidates.filter((_, i) => i !== index);
        setCandidates(newCandidates);
    };  

    const handleCloseUploadCvModal = () => {
        setUploadCvError('');
        setShowUploadCvModal(false);
    };

    const handleUploadCandidateCvs = () => {
        setShowUploadCvModal(true);
        fetchSupportedSbpPartners(parseInt(deploymentRequestId));
    };

    const uploadCandidateCvsDeploymentRequest = async () => {
        const formData = new FormData();
        let isValid = true;
        let errors = [];
        candidates.forEach((candidate, index) => {
            if(!candidate.sbpPartnerId){
                isValid = false;
                errors.push(`Candidate ${index + 1}: Partner Name is required.`);
            }
            if(!candidate.supportType){
                isValid = false;
                errors.push(`Candidate ${index + 1}: Support Type is required.`);
            }
            if (!candidate.candidateName || candidate.candidateName.trim() === "") {
                isValid = false;
                errors.push(`Candidate ${index + 1}: Name is required.`);
            }
            if (!candidate.file) {
                isValid = false;
                errors.push(`Candidate ${index + 1}: File is required.`);
            } else {
                const allowedExtensions = ["pdf", "doc", "docx"];
                const fileExtension = candidate.file.name.split('.').pop().toLowerCase();
    
                if (!allowedExtensions.includes(fileExtension)) {
                    isValid = false;
                    errors.push(`Candidate ${index + 1}: Only PDF, DOC, or DOCX files are allowed.`);
                }
    
                const maxSizeInMB = 5;
                if (candidate.file.size > maxSizeInMB * 1024 * 1024) {
                    isValid = false;
                    errors.push(`Candidate ${index + 1}: File size should not exceed ${maxSizeInMB}MB.`);
                }
            }
            if (isValid) {
                formData.append(`Candidates[${index}].DeploymentType`, selectedDeploymentType);
                formData.append(`Candidates[${index}].DeploymentRequestId`, parseInt(deploymentRequestId));
                formData.append(`Candidates[${index}].SbpPartnerId`, parseInt(candidate.sbpPartnerId));
                formData.append(`Candidates[${index}].CandidateName`, candidate.candidateName);
                formData.append(`Candidates[${index}].File`, candidate.file);
            }
        });
        if (!isValid) {
            setUploadCvError(errors.join("\n")); 
            return;
        }
        try {
            const res = await UploadCandidatesCv(formData);
            handleCloseUploadCvModal();
            if (res.data.success) {
                showModal('success', res.data.message);
                fetchDeploymentRequestData(parseInt(deploymentRequestId));
            } else {
                showModal('failure', res.data.message);
            }
        } catch (error) {
            handleCloseUploadCvModal();
            showModal('failure', "An error occurred while uploading. Please try again. "+error);
        }
    };    

    ///Candidate Selection
    const handleCandidateSelectionNotification = () => {
        openModal(
            'Confirmation',
            <>
            Are you sure you want to Send the Notification?.
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Send'
            );
    };

    ////Section for Select Candidate
    const handleSelectCandidate = () =>{
        fetchUploadedCandidates(parseInt(deploymentRequestId));
        setShowSelectCandidateModal(true);
    };

    const handleCloseSelectCandidateModal = () => {
        setSelectedCandidateId('');
        setCandidateEmailId('');
        setSelectCandidateError('');
        setShowSelectCandidateModal(false);
    };

    const updateSelectedCandidateSbpRequest = async() => {
        let isValid = true;
        let errors = [];
        if (!selectedCandidateId) {
            isValid = false;
            errors.push('Candidate Name is required.');
        }
        if (!candidateEmailId) {
            isValid = false;
            errors.push('Candidate Email is required.');
        }
        if (candidateEmailId) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(candidateEmailId)) {
                isValid = false;
                errors.push('Please enter a valid Candidate Email.');
            }
        }
        if (!isValid) {
            setSelectCandidateError(errors.join("\n")); 
            return;
        }else{
            var payload = {
                deploymentRequestId,
                deploymentRequestCvId : parseInt(selectedCandidateId),
                candidateEmailId : candidateEmailId.trim()
            };
            try {
                const res = await SelectCandidateRecord(payload);
                handleCloseSelectCandidateModal();
                if (res.data.success) {
                    showModal('success', res.data.message);
                    fetchDeploymentRequestData(parseInt(deploymentRequestId));
                } else {
                    showModal('failure', res.data.message);
                }
            } catch (error) {
                showModal('failure', "An error occurred while updating the record. Please try again. " + error);
                handleCloseSelectCandidateModal();
            }
        }        
    };

    ////RLA Upload Document and Approve Signed Document
    const validateRlaDraftingDetails = () => {        
        const newErrors = {};
        if (!rlaDocument) newErrors.rlaDocument = 'RLA Document is required';
        if (!rlaFundingType) newErrors.rlaFundingType = 'Funding is required';
        if (!rlaBudget) newErrors.rlaBudget = 'Budget is required';
        if (!rlaRemarks) newErrors.rlaRemarks = 'Remark is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSendRlaDocumentToRequesters = async() =>{
        if(!validateRlaDraftingDetails()){
            return;
        } 
        openModal(
            'Confirmation',
            <>
            Are you sure you want to Send the RLA Document to Requesters?.
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Send To Requester'
        );
    };

    const validateApproveRla = () => {        
        const newErrors = {};
        if (!rlaSignedDocument) newErrors.rlaSignedDocument = 'RLA Signed Document is required';
        if (!rlaWbl) newErrors.rlaWbl = 'WBL is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleApproveRla = () => {
        if(!validateApproveRla()){
            return;
        } 
        openModal(
            'Confirmation',
            <>
            Are you sure you want to Send the RLA Signed Document?.
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Approve RLA'
        );
    };

    ////Onboarding Document Upload
    const handleOnboardingDocumentChange = (index, event) => {
        const { name, value, files } = event.target;
        const newOnboardingDocument = [...onboardingDocuments];
        if (name === "documentTypeId") {
            const selectedDocType = allDocumentTypes.find(doc => doc.documentTypeId === parseInt(value));
    
            newOnboardingDocument[index][name] = parseInt(value);
            newOnboardingDocument[index]["showOtherDocumentType"] = selectedDocType && selectedDocType.documentTypeName === "Others";
            if (!newOnboardingDocument[index]["showOtherDocumentType"]) {
                newOnboardingDocument[index]["otherDocumentType"] = "";
            }
        }else {
            newOnboardingDocument[index][name] = files ? files[0] : value;
        }
        setOnboardingDocuments(newOnboardingDocument);
    };      
    
    const addOnboardingDocumentRow = () => {
        setOnboardingDocuments([...onboardingDocuments, { deploymentType: "", deploymentRequestId: "", documentTypeId: "", showOtherDocumentType:"", otherDocumentType: "", file: null  }]);
    };
    
    const removeOnboardingDocumentRow = (index) => {
        const newOnboardingDocument = onboardingDocuments.filter((_, i) => i !== index);
        setOnboardingDocuments(newOnboardingDocument);
    };

    const handleUploadOnboardingDoc = async() => {
        if (onboardingDocuments.length === 0) {
            showModal("failure","Please add at least one document before uploading.");
            return;
        }    
        // Validate each document entry
        for (let i = 0; i < onboardingDocuments.length; i++) {
            const doc = onboardingDocuments[i];    
            if (!doc.documentTypeId) {
                showModal("failure",`Please select a document type for document ${i + 1}.`);
                return;
            }
            if (doc.showOtherDocumentType && !doc.otherDocumentType.trim()) {
                showModal("failure",`Please enter the Other Document Type for document ${i + 1}.`);
                return;
            }
            if (!doc.file) {
                showModal("failure",`Please upload a file for document ${i + 1}.`);
                return;
            }
        }    
        const formData = new FormData();
        onboardingDocuments.forEach((document, index) => {
            formData.append(`documents[${index}].DeploymentType`, selectedDeploymentType);
            formData.append(`documents[${index}].DeploymentRequestId`, parseInt(deploymentRequestId));
            formData.append(`documents[${index}].DocumentTypeId`, parseInt(document.documentTypeId));
            formData.append(`documents[${index}].OtherDocumentType`, document.otherDocumentType || "");
            formData.append(`documents[${index}].File`, document.file);
        });
        const res = await UploadOnboardingDocuments(formData);
        if (res.data.success) {
            showModal('success', res.data.message);
            fetchDeploymentRequestData(parseInt(deploymentRequestId));
        } else {
            showModal('failure', res.data.message);
        }
    };    
    
    const handleNotifyOnboardingDoc = async() =>{
        const formData = new FormData();
        formData.append('deploymentRequestId', deploymentRequestId);
        formData.append('deploymentTypeText', selectedDeploymentType);
        formData.append('requestedTeamName',selectedSupportingTeam);
        formData.append('requestCode', requestCode);
        formData.append('postionHeader', deploymentRequestPosition);
        formData.append('dutyStation', dutyStation);
        const res = await NotifyRequestersRegardingOnboardingDocs(formData);
        if (res.data.success) {
            showModal('success', res.data.message);
            fetchDeploymentRequestData(parseInt(deploymentRequestId));
        } else {
            showModal('failure', res.data.message);
        }
    };

    const validateDeploymentDates = () => {        
        const newErrors = {};
        if (!actualFromDate) newErrors.actualFromDate = 'Actual From Date is required';
        if (!actualToDate) newErrors.actualToDate = 'Actual To Date is required';
        if (actualFromDate && actualToDate) {
            if (new Date(actualToDate) < new Date(actualFromDate)) {
                newErrors.actualToDate = 'Actual To Date should not be earlier than Actual From Date.';
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleUpdateDeploymentDates = () => {
        if(!validateDeploymentDates()){
            return;
        } 
        openModal(
            'Confirmation',
            <>
            Are you sure you want to Update Deployment Dates?.
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Update Deployment Dates'
        );
    };
    
    ///Send Check-in survey to candidate
    function addTwoWeeks(date) {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + 14); 
        return newDate;
    }

    const checkinSurveyVisibilityDate = addTwoWeeks(actualFromDateView);
    const handleSendCheckinSurvey = () => {
        openModal(
            'Confirmation',
            <>
            Are you sure you want to Send Check-in Survey to Candidate?.
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Send Check-in Survey'
        );
    };

    const validateCheckinSurvey = () => {
        const newErrors = {};
        if (!surveyStatus) newErrors.surveyStatus = 'Status is required';
        if (!surveyCompleteDate) newErrors.surveyCompleteDate = 'Complete Date is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleUpdateSurvey = () => {
        if(!validateCheckinSurvey()){
            return;
        }
        openModal(
            'Confirmation',
            <>
            Are you sure you want to Update Check-in Survey?.
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Update Check-in Survey'
        );        
    };

    ////Performance Evaluation
    function oneMonthBefore(date){
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() - 28); 
        return newDate;
    }

    const performanceEvaluationVisibilityDate = oneMonthBefore(actualToDateView);

    const handlePerformanceEvaluation = () => {
        openModal(
            'Confirmation',
            <>
            Are you sure you want to Send Performance Evaluation Report?.
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Performance Evaluation'
        );
    };

    const validatePerDocuments = () => {
        const newErrors = {};
        if (!perDocument) newErrors.perDocument = 'PER Document is required';
        if (!perStatus) newErrors.perStatus = 'PER Status is required';
        if (!perUploadDate) newErrors.perUploadDate = 'PER Upload Date is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleUploadPerDocument = () => {
        if(!validatePerDocuments()){
            return;
        }
        openModal(
            'Confirmation',
            <>
            Are you sure you want to Upload PER Document?.
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Upload PER Document'
        );
    }

    ///Request RLA Invoice from SBP Partners
    function oneMonthAfter(date){
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + 28); 
        return newDate;
    }

    const rlaInvoiceVisibilityDate = oneMonthAfter(actualToDateView);

    const handleRequestRLAInvoice = () =>{
        openModal(
            'Confirmation',
            <>
            Are you sure you want to Send Notification to SBP Partner?.
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Notify SBP Partner'
        );
    };

    const validateRlaInvoice = () => {
        const newErrors = {};
        if (!rlaInvoice) newErrors.rlaInvoice = 'RLA Invoice is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleUploadRlaInvoice = () =>{
        if(!validateRlaInvoice()){
            return;
        }
        openModal(
            'Confirmation',
            <>
            Are you sure you want to Upload RLA Invoice?.
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Upload Invoice'
        );
    };

    ///Proof of Payment
    const validateProofOfPayment = () => {
        const newErrors = {};
        if (!proofOfPayment) newErrors.proofOfPayment = 'Proof of Payment is required';
        if (!paymentRemark) newErrors.paymentRemark = 'Payment Remark is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleUploadProofOfPayment = () => {
        if(!validateProofOfPayment()){
            return;
        }
        openModal(
            'Confirmation',
            <>
            Are you sure you want to Upload Proof of Payment?.
            <span style={{ color: 'red' }}>*</span>
            </>,
            'Upload Proof of Payment'
        );
    };

    return (
        <>
            <Header />
            <div className="d-flex">
                <Sidebar />
                <div className="main bg-light-iom">
                    <div className='dashboard-class'>
                        <div className='cont-wrapper'>
                            <div className="container mt-5">
                                {showDeatils && (
                                    <div className="card mb-3">
                                        <div className='card-header'>
                                            <strong>Request Code :</strong> {requestCode } | <strong>Current Status :</strong> <span style={{color: requestStatus === 'Submitted for COM/HOD Approval' ? 'blue' : requestStatus === 'Submitted' ? 'blue' : requestStatus === 'Launched' ? 'green' : requestStatus === 'SBP Partner Coordination' ? 'green' : requestStatus === 'Candidate Selection' ? 'green' : requestStatus === 'Candidate Selected' ? 'green' : requestStatus === 'Submitted for Approval' ? 'green' : requestStatus === 'Ongoing Deployment' ? 'green' : requestStatus === 'Rejected' ? 'red' : requestStatus === 'Reverted' ? 'orange' : requestStatus === 'In Progress' ? 'green' : requestStatus === 'Completed SBP Deployment' ? '#0033A0' : 'black', fontWeight:'bold'}}>{requestStatus}</span>
                                            <button className="btn" style={{float:'right', color:'#265aeda6', fontWeight: 'bold'}} onClick={handleShowRemarks}>Remarks</button>
                                            <button className="btn" style={{float:'right', color:'#265aeda6', fontWeight: 'bold'}} onClick={handleShowHistory}>History</button>
                                        </div>
                                        <div className='card-body'>
                                            <div className='responseevents'>
                                                <div className='section-header'>
                                                    <span>Response & Deployment Type</span>
                                                </div>
                                                <div className='row'>
                                                    <div className="form-group mb-3 col-md-4">
                                                        <label htmlFor="responseEvent" className="form-label">Response/Event</label>
                                                        <select id="responseEvent" className="form-select" value={selectedResponseEvent} onChange={(e) => handleInputChange(e, setSelectedResponseEvent, 'selectedResponseEvent')} disabled={responseEventsVisibilityStatus.includes(requestStatus)}>
                                                            <option value="">--Select--</option>
                                                            {responseEvents.map((res) => (
                                                                <option key={res.responseId} value={res.responseId}>{res.responseDescription}</option>
                                                            ))}
                                                        </select>
                                                        {errors.selectedResponseEvent && <p style={{color: 'red'}}>{errors.selectedResponseEvent}</p>}
                                                    </div>
                                                    <div className="form-group mb-3 col-md-4">
                                                        <label htmlFor="deploymentType" className="form-label">Deployment Type <span style={{color:"red", font:"bold"}}>*</span></label>
                                                        <input type="text" className="form-control" id="deploymentType" placeholder="Deployment Type" value={selectedDeploymentType} disabled />
                                                    </div>
                                                    <div className="form-group mb-3 col-md-4">
                                                        <label htmlFor="supportingTeam" className="form-label">Requested Team <span style={{color:"red", font:"bold"}}>*</span></label>
                                                        <input type="text" className="form-control" id="supportingTeam" placeholder="Requested Team" value={selectedSupportingTeam} disabled />
                                                    </div>                                            
                                                </div>
                                                <div className='row'>
                                                    <div className="form-group mb-3 col-md-12">
                                                        <label htmlFor="ccUsersMail" className="form-label" title="Provide the Cc Emails in comma separated format">Cc Emails</label>
                                                        <input type="text" className="form-control" id="ccUsersMail" placeholder="Provide the Cc Emails in comma separated format" value={ccUsersMail} onChange={(e) => setCcUsersMail(e.target.value)} disabled={!isCcMailEditing}/>
                                                            {requestStatus !== 'Completed' &&(
                                                                <>
                                                                {isCcMailEditing ? (<button type="button" onClick={handleSaveCcUsersClick} className="btn btn-primary btn-sm" style={{position: 'absolute', right: '20px', transform: 'translateY(-112%)', background: 'none', color: '#28a745', border: 'none'}}><i class="bi bi-floppy"></i></button>) : (
                                                                    <button type="button" onClick={handleEditCcUsersClick} className="btn btn-secondary btn-sm" style={{position: 'absolute', right: '20px', transform: 'translateY(-112%)', background: 'none', border: 'none'}}><i className="bi bi-pencil" style={{color:'#ffc107'}}></i></button>
                                                                )}
                                                                {ccUserEmailIdError && (<p style={{color: 'red'}}>{ccUserEmailIdError}</p>)}
                                                                </>
                                                            )}
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='form-group col-md-6 mb-3'>
                                                        <label htmlFor="isRequestExtension" className='form-label'>Is it Extension of a previous request? </label>
                                                        <input type="text" className="form-control" id="isRequestExtension" value={isRequestExtension === false ? 'No' : 'Yes'} disabled />
                                                    </div>
                                                    {isRequestExtension && (
                                                    <div className='form-group col-md-6 mb-3'>
                                                        <label htmlFor="existingRequestCode" className='form-label'>Previous Request Code </label>
                                                        <input type="text" className="form-control" id="existingRequestCode" value={existingRequestCode} disabled />
                                                    </div>
                                                    )}
                                                </div>
                                            </div>
                                            {isSBP && (<>
                                                <div className='responseevents'>
                                                    <div className='section-header'>
                                                        <span>Position Specific Information - {deploymentRequestPosition}</span>
                                                        <button className="btn" style={{float:'right', color:'white', fontWeight: 'bold'}} onClick={handleOpenPopup}>View Position Details</button>
                                                    </div>
                                                    <div className='form-outline'>
                                                        <fieldset>
                                                            <div className='row'>
                                                                <div className="form-group mb-1 col-md-3">
                                                                    <label htmlFor='dutyStation' className='form-label'>
                                                                        <strong>Duty Station:</strong> {dutyStation}
                                                                    </label>
                                                                </div>
                                                                <div className="form-group mb-1 col-md-3">
                                                                    <label htmlFor='positionLevel' className='form-label'>
                                                                        <strong>Position Level:</strong> {selectedPositionLevel}
                                                                    </label>
                                                                </div>
                                                                <div className="form-group mb-1 col-md-3">
                                                                    <label htmlFor='positionType' className='form-label'>
                                                                        <strong>Position Type:</strong> {selectedPositionType}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className="form-group col-md-3">
                                                                    <label htmlFor='dateFrom' className='form-label me-2'>
                                                                        <strong>Target From Date:</strong> {fromDate !== null ? formatDate(fromDate) : null}
                                                                    </label>
                                                                </div>
                                                                <div className="form-group col-md-3">
                                                                    <label htmlFor='toDate' className='form-label me-2'>
                                                                        <strong>Target To Date:</strong> {toDate !== null ? formatDate(toDate) : null}
                                                                    </label>
                                                                </div>
                                                                <div className="form-group col-md-3">
                                                                    <label htmlFor='estimatedCost' className='form-label'>
                                                                        <strong>Requested Duration:</strong> {fromDate && toDate ? (<> {calculateDaysInclusive(fromDate, toDate)} <span>Days</span> </>):''}
                                                                    </label>
                                                                </div>
                                                                <div className='form-group col-md-3'>
                                                                    <label htmlFor='torDocument' className='form-label'>
                                                                        <strong>Tor Document: </strong> {uploadedDocumentName && (<button style={{textAlign:'right', color:'#265aeda6', background:'none', border: 'none', fontWeight:'bold'}} onClick={() => handleDownloadDocument(uploadedDocumentName, torDocumentPath)} title={uploadedDocumentName}>Download</button>)}
                                                                    </label>
                                                                </div>
                                                            </div>                                                    
                                                        </fieldset>
                                                    </div>                                                                                                
                                                </div>
                                                <div className='responseevents'>
                                                    <div className='section-header'>
                                                        <span>COM/HOD Approval Details</span>
                                                    </div>
                                                    <div className='form-outline'>
                                                        <fieldset>
                                                            <div className='row'>
                                                                <div className="form-group col-md-3">
                                                                    <label htmlFor='comApproverName' className='form-label'>
                                                                        <strong>Name:</strong> {comHodFullName}
                                                                    </label>
                                                                </div>
                                                                <div className="form-group col-md-3">
                                                                    <label htmlFor='comApprovalDate' className='form-label'>
                                                                        <strong>Date:</strong> {comHodApprovalDate !== null ? formatDate(comHodApprovalDate) : null}
                                                                    </label>
                                                                </div>
                                                                <div className="form-group col-md-3">
                                                                    <label htmlFor='comApprovalStatus' className='form-label'>
                                                                        <strong>Status: <span style={{color: comHodApprovalStatus === 'Pending' ? 'orange' : comHodApprovalStatus === 'Approved' ? 'green' : 'red'}}>{comHodApprovalStatus}</span></strong>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </fieldset>
                                                    </div>
                                                </div> 
                                                {sbpPartnerName && (
                                                    <>
                                                        <div className='responseevents'>
                                                            <div className='section-header'>
                                                                <span>Send To SBP Partners</span>
                                                            </div>
                                                            <div className='form-outline'>
                                                                <fieldset>
                                                                    <div className='row align-items-center'>
                                                                        <div className="form-group col-md-6">
                                                                            <label htmlFor="sbpPartnerName" className="form-label"><strong>SBP Partner Name: </strong>{sbpPartnerName.length > 35 ? (
                                                                                <>
                                                                                    {sbpPartnerName.substring(0, 35)}...
                                                                                    <a href="#" onClick={(e) => {e.preventDefault(); handleShowSbpPartnersNameModal();}}>
                                                                                        View More
                                                                                    </a>
                                                                                </>
                                                                                ) : (
                                                                                <>
                                                                                    {sbpPartnerName}
                                                                                    <a href="#" onClick={(e) => {e.preventDefault(); handleShowSbpPartnersNameModal();}}>
                                                                                        View More
                                                                                    </a> 
                                                                                </>
                                                                                )}
                                                                            </label>
                                                                        </div>
                                                                        <div className='form-group col-md-3'>
                                                                            <label htmlFor='sbpSendToDate' className='form-label'><strong>Sent Date: </strong>{sendToDate !== null ? formatDate(sendToDate) : null }</label>
                                                                        </div>
                                                                        {userHasSendToSBPAgencies && sendSBPPartnersButtonVisibilityStatus.includes(requestStatus) && (
                                                                        <div className='form-group col-md-3 d-flex justify-content-end'>
                                                                            <button className="btn" style={{float:'right', padding: '0px 0 4px 0', color:'#265aeda6', fontWeight: 'bold'}} onClick={() => handleSendToSbpPartners('reminder')}>Send Reminder to SBP Partners</button>
                                                                        </div>
                                                                        )}                                                                    
                                                                    </div>
                                                                </fieldset>
                                                            </div>
                                                        </div> 
                                                    </>
                                                )}  
                                                {uploadedCandidateCVs && uploadedCandidateCVs.some(cv => cv.candidateName && cv.uploadedDocumentName && cv.uploadedDocumentPath && cv.uploadedDate) && (   
                                                <div className='responseevents'>
                                                    <div className='section-header'>
                                                        <span>Uploaded Candidate's CV</span>
                                                    </div>
                                                    <div className='form-outline'>
                                                        <fieldset>
                                                        {uploadedCandidateCVs.map((cv, index) => (
                                                            <div key={index} className="row">
                                                                <div className="form-group col-md-2">
                                                                    <label htmlFor={`supportType_${index}`} className='form-label'>
                                                                        <strong>{index+1}. Support Type:</strong> {cv.supportType}
                                                                    </label>
                                                                </div>
                                                                <div className="form-group col-md-3">
                                                                    <label htmlFor={`partnerName_${index}`} className='form-label'>
                                                                        <strong>Partner Name:</strong> {cv.partnerName}
                                                                    </label>
                                                                </div>
                                                                <div className="form-group col-md-3">
                                                                    <label htmlFor={`candidateName_${index}`} className='form-label'>
                                                                        <strong>Candidate Name:</strong> {cv.candidateName}
                                                                    </label>
                                                                </div>
                                                                <div className="form-group col-md-3">
                                                                    <label htmlFor={`candidateName_${index}`} className='form-label'>
                                                                        <strong>Uploaded On:</strong> {cv.uploadedDate !== null ? formatDate(cv.uploadedDate) : null}
                                                                    </label>
                                                                </div>
                                                                <div className='form-group col-md-1'>
                                                                    <button className='btn btn-sm me-4' style={{float:'right'}} onClick={() => handleDownloadDocument(cv.uploadedDocumentName, cv.uploadedDocumentPath)}><i class="bi bi-download" style={{color:'#0000ff'}}></i></button>
                                                                </div>
                                                                {index !== uploadedCandidateCVs.length - 1 && <hr />}
                                                            </div>                                                        
                                                        ))}
                                                        </fieldset>
                                                    </div>
                                                </div> 
                                                )}  
                                                {hasValidCVs &&(
                                                    <div className='responseevents'>
                                                        <div className='section-header'>
                                                            <span>Candidate Selection</span>
                                                        </div>
                                                        <div className='form-outline'>
                                                            <fieldset>
                                                                <div className='row'>
                                                                    {!candidateSelectionRemarkView ? (
                                                                        <>
                                                                            <div className="form-group mb-2 col-md-12">
                                                                                <label htmlFor='candidateSelectionRemarkEdit' className='form-label'>
                                                                                    Remark <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                </label>
                                                                                <textarea 
                                                                                    className='form-control col-md-12' 
                                                                                    id='candidateSelectionRemarkEdit' 
                                                                                    value={candidateSelectionRemarkEdit} 
                                                                                    onChange={(e) => handleInputChange(e, setCandidateSelectionRemarkEdit, 'candidateSelectionRemarkEdit')} 
                                                                                    rows="4">
                                                                                </textarea>
                                                                            </div>  
                                                                            <div className='form-group' style={{ textAlign: 'right' }}>
                                                                                <button type="submit" id="btnSendNotification" className="btn btn-primary me-2" onClick={handleCandidateSelectionNotification}>
                                                                                    Send Notification
                                                                                </button>
                                                                            </div>  
                                                                        </>
                                                                    ) : (
                                                                        <div className="form-group col-md-12">
                                                                            <label htmlFor='candidateSelectionRemarkView' className='form-label'>
                                                                                <strong>Remark:</strong> {candidateSelectionRemarkView}
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </fieldset>
                                                        </div>
                                                    </div> 
                                                )}
                                                {selectedCandidateName && candidateEmailId && selectedDate && (
                                                    <div className='responseevents'>
                                                        <div className='section-header'>
                                                            <span>Selected Candidate Details</span>
                                                        </div>
                                                        <div className='form-outline'>
                                                            <fieldset>
                                                                <div className='row align-items-center'>
                                                                    <div className='form-group col-md-2'>
                                                                        <label htmlFor='selectedSupportType' className='form-label'><strong>Support Type: </strong>{selectedSupportType}</label>
                                                                    </div>
                                                                    <div className='form-group col-md-3'>
                                                                        <label htmlFor='selectedPartnerName' className='form-label'><strong>Partner Name: </strong>{selectedPartnerName}</label>
                                                                    </div> 
                                                                    <div className="form-group col-md-3">
                                                                        <label htmlFor="selectedCandidateName" className="form-label"><strong>Candidate Name: </strong>{selectedCandidateName}</label>
                                                                    </div>
                                                                    <div className='form-group col-md-2'>
                                                                        <label htmlFor='CandidateEmailId' className='form-label'><strong>Email: </strong>{candidateEmailId}</label>
                                                                    </div>  
                                                                    <div className='form-group col-md-2'>
                                                                        <label htmlFor='selectedDate' className='form-label'><strong>Selected Date: </strong>{selectedDate !== null ? formatDate(selectedDate) : null }</label>
                                                                    </div>                                                           
                                                                </div>
                                                            </fieldset>
                                                        </div>
                                                    </div> 
                                                )}  
                                                {rlaSelectedCandidateVisibilityStatus.includes(requestStatus) && selectedSupportType === 'Supported on RLA' && (
                                                    <div className='responseevents'>
                                                        <div className='section-header'>
                                                            <span>RLA Drafting</span>
                                                        </div>
                                                        <div className='form-outline'>
                                                            <fieldset>                                                                
                                                                {(userInfo.isAdmin || userHasRLACoordinator) && !uploadedRlaDocumentName && !uploadedRlaDocumentPath && (
                                                                    <>
                                                                        <div className='row'>
                                                                            <div className="form-group mb-2 col-md-4">
                                                                                <label htmlFor='rlaDocument' className='form-label'>
                                                                                    RLA Document <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                </label>
                                                                                <input type="file" className="form-control" id='rlaDocument' onChange={(e) => handleInputChange(e, setRlaDocument, 'rlaDocument')}/>
                                                                                {errors.rlaDocument && <p style={{color: 'red'}}>{errors.rlaDocument}</p>}
                                                                            </div>  
                                                                            <div className="form-group mb-2 col-md-4">
                                                                                <label htmlFor='rlaFundingType' className='form-label'>
                                                                                    Funding Type <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                </label>
                                                                                <select id="rlaFundingType" className="form-select" value={parseInt(rlaFundingType)} onChange={(e) => handleInputChange(e, setRlaFundingType, 'rlaFundingType')}>
                                                                                    <option value="">--Select--</option>
                                                                                    {allFundingTypes.map((res) => (
                                                                                        <option key={res.fundingTypeId} value={parseInt(res.fundingTypeId)}>{res.fundingTypeName}</option>
                                                                                    ))}
                                                                                </select>
                                                                                {errors.rlaFundingType && <p style={{color: 'red'}}>{errors.rlaFundingType}</p>}
                                                                            </div> 
                                                                            <div className="form-group mb-2 col-md-4">
                                                                                <label htmlFor='rlaBudget' className='form-label'>
                                                                                    Budget <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                </label>
                                                                                <input type="text" className="form-control" id="rlaBudget" value={rlaBudget} onChange={(e) => handleInputChange(e, setRlaBudget, 'rlaBudget')}/>
                                                                                {errors.rlaBudget && <p style={{color: 'red'}}>{errors.rlaBudget}</p>}
                                                                            </div>
                                                                        </div> 
                                                                        <div className='row'>
                                                                            <div className='form-group mb-2 col-md-8'>
                                                                                <label htmlFor='rlaRemarks' className='form-label'>
                                                                                    Remarks <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                </label>
                                                                                <input type="text" className="form-control" id="rlaRemarks" value={rlaRemarks} onChange={(e) => handleInputChange(e, setRlaRemarks, 'rlaRemarks')}/>
                                                                                {errors.rlaRemarks && <p style={{color: 'red'}}>{errors.rlaRemarks}</p>}
                                                                            </div>
                                                                            <div className='mb-2 col-md-4' style={{ textAlign: 'right', marginTop:'32px' }}>
                                                                                <button type="submit" id="btnSendToRequesters" className="btn btn-primary me-2" onClick={handleSendRlaDocumentToRequesters}>Send to Requester</button>
                                                                            </div> 
                                                                        </div>                                                                         
                                                                    </>
                                                                )}
                                                                {uploadedRlaDocumentName && uploadedRlaDocumentPath && (
                                                                    <>
                                                                        <div className='row'>                                                                            
                                                                            <div className="form-group col-md-3">
                                                                                <label htmlFor='rlaDocumentPath' className='form-label'><strong>Uploaded Documents: </strong>{uploadedRlaDocumentName}</label>
                                                                            </div>
                                                                            <div className="form-group col-md-3">
                                                                                <label htmlFor='rlaFundingTypeView' className='form-label'><strong>Funding Type: </strong>{rlaFundingTypeView}</label>
                                                                            </div>
                                                                            <div className="form-group col-md-2">
                                                                                <label htmlFor='rlaBudget' className='form-label'><strong>Budget: </strong>{rlaBudget}</label>
                                                                            </div>
                                                                            <div className="form-group col-md-3">
                                                                                <label htmlFor='rlaRemarks' className='form-label'><strong>Remarks: </strong>{rlaRemarks}</label>
                                                                            </div>
                                                                            <div className='form-group col-md-1'>
                                                                                <button className='btn btn-sm' style={{float:'right'}} onClick={() => handleDownloadDocument(uploadedRlaDocumentName, uploadedRlaDocumentPath)}><i class="bi bi-download" style={{color:'#0000ff'}}></i></button>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}                                                                
                                                            </fieldset>
                                                        </div>
                                                    </div>
                                                )}
                                                {rlaSelectedCandidateVisibilityStatus.includes(requestStatus) && selectedSupportType === 'Supported on RLA' && uploadedRlaDocumentName && uploadedRlaDocumentPath && (
                                                    <div className='responseevents'>
                                                        <div className='section-header'>
                                                            <span>RLA Approval</span>
                                                        </div>
                                                        <div className='form-outline'>
                                                            <fieldset>                                                                
                                                                {(userInfo.isAdmin || userHasRLAApproval) && !signedRlaDocumentName && !signedRlaDocumentPath && (
                                                                    <>
                                                                        <div className='row'>
                                                                            <div className="form-group mb-2 col-md-5">
                                                                                <label htmlFor='rlaDocument' className='form-label'>
                                                                                    RLA Signed Document <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                </label>
                                                                                <input type="file" className="form-control" id='rlaSignedDocument' onChange={(e) => handleInputChange(e, setRlaSignedDocument, 'rlaSignedDocument')}/>
                                                                                {errors.rlaSignedDocument && <p style={{color: 'red'}}>{errors.rlaSignedDocument}</p>}
                                                                            </div>   
                                                                            <div className="form-group mb-2 col-md-5">
                                                                                <label htmlFor='rlaBudget' className='form-label'>
                                                                                    WBL <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                </label>
                                                                                <input type="text" className="form-control" id="rlaWbl" value={rlaWbl} onChange={(e) => handleInputChange(e, setRlaWbl, 'rlaWbl')}/>
                                                                                {errors.rlaWbl && <p style={{color: 'red'}}>{errors.rlaWbl}</p>}
                                                                            </div>
                                                                            <div className='mb-2 col-md-2' style={{ textAlign: 'right', marginTop:'32px' }}>
                                                                                <button type="submit" id="btnApproveRla" className="btn btn-primary me-2" onClick={handleApproveRla}>Approve RLA</button>
                                                                            </div>
                                                                        </div>                                                                       
                                                                    </>
                                                                )}
                                                                {signedRlaDocumentName && signedRlaDocumentPath && (
                                                                    <>
                                                                        <div className='row'>                                                                            
                                                                            <div className="form-group col-md-4">
                                                                                <label htmlFor='signedRlaDocumentPath' className='form-label'><strong>Uploaded Documents: </strong>{signedRlaDocumentName}</label>
                                                                            </div>
                                                                            <div className="form-group col-md-6">
                                                                                <label htmlFor='rlaWbl' className='form-label'><strong>WBL: </strong>{rlaWbl}</label>
                                                                            </div>
                                                                            <div className='form-group col-md-2'>
                                                                                <button className='btn btn-sm' style={{float:'right'}} onClick={() => handleDownloadDocument(signedRlaDocumentName, signedRlaDocumentPath)}><i class="bi bi-download" style={{color:'#0000ff'}}></i></button>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}                                                                
                                                            </fieldset>
                                                        </div>
                                                    </div>
                                                )} 
                                                {rlaSelectedCandidateVisibilityStatus.includes(requestStatus) && requestStatus != 'Ongoing Deployment' && (
                                                    (selectedSupportType === 'Supported on RLA' && uploadedRlaDocumentName && uploadedRlaDocumentPath && signedRlaDocumentName && signedRlaDocumentPath && (
                                                        <div className='responseevents'>
                                                            <div className='section-header'>
                                                                <span>Onboarding Documents</span>
                                                            </div>
                                                            <div className='form-outline'>
                                                                <fieldset>
                                                                    {(userInfo.isAdmin || userHasApproveSBPRequest || userHasReviewSBPRequest) && (!uploadedOnboardingDocuments || uploadedOnboardingDocuments.length === 0) && (
                                                                        <>
                                                                            {onboardingDocuments.map((doc, index) => (
                                                                                <div key={index} className="row mb-2">
                                                                                    <div className='form-group col-md-3'>
                                                                                        <label htmlFor={`documentType_${index}`} className='form-label'>
                                                                                            Document Type <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                        </label>
                                                                                        <select id={`documentType_${index}`} className="form-select" name='documentTypeId' value={doc.documentTypeId} onChange={(e) => handleOnboardingDocumentChange(index, e)}>
                                                                                            <option value="">--Select Document Type--</option>
                                                                                                {allDocumentTypes.map((prt) => (
                                                                                                    <option key={prt.documentTypeId} value={parseInt(prt.documentTypeId)}>{prt.documentTypeName}</option>
                                                                                                ))}
                                                                                        </select>
                                                                                    </div>
                                                                                    {doc.showOtherDocumentType && (
                                                                                    <div className='form-group col-md-4'>
                                                                                        <label htmlFor={`otherDocumentType_${index}`} className='form-label'>
                                                                                        Other Document Type <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                        </label>
                                                                                        <input type="text" id={`otherDocumentType_${index}`} className="form-control" name="otherDocumentType" value={doc.otherDocumentType} onChange={(e) => handleOnboardingDocumentChange(index, e)} />
                                                                                    </div>
                                                                                    )}
                                                                                    <div className='form-group col-md-3'>
                                                                                        <label htmlFor={`uploadFile_${index}`} className='form-label'>
                                                                                        Upload File <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                        </label>
                                                                                        <input type="file" className="form-control" name="file" onChange={(e) => handleOnboardingDocumentChange(index, e)} />
                                                                                    </div>                                        
                                                                                    <div className='form-group col-md-2' style={{marginTop: '30px'}}>
                                                                                        <button type="button" className='btn btn-primary me-2' onClick={addOnboardingDocumentRow}><i className="bi bi-plus-circle"></i></button>
                                                                                        {onboardingDocuments.length > 1 && (
                                                                                        <button type="button" className='btn btn-danger' onClick={() => removeOnboardingDocumentRow(index)}><i className="bi bi-dash-circle"></i></button>
                                                                                        )}
                                                                                    </div>                                    
                                                                                </div>                
                                                                            ))}
                                                                            {(userInfo.isAdmin || userHasApproveSBPRequest) && (
                                                                            <div className='row'>
                                                                                <div className='mb-2 col-md-12' style={{ textAlign: 'right' }}>
                                                                                    <button type="submit" id="btnUploadOnboardingDoc" className="btn btn-primary me-2" onClick={handleUploadOnboardingDoc}>Upload</button>
                                                                                </div>
                                                                            </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </fieldset>
                                                            </div>
                                                        </div>
                                                    )) || 
                                                    (selectedSupportType === 'Supported' && (
                                                        <div className='responseevents'>
                                                            <div className='section-header'>
                                                                <span>Onboarding Documents</span>
                                                            </div>
                                                            <div className='form-outline'>
                                                                <fieldset>
                                                                    {(!uploadedOnboardingDocuments || uploadedOnboardingDocuments.length === 0) && (
                                                                        <>
                                                                            {onboardingDocuments.map((doc, index) => (
                                                                                <div key={index} className="row mb-2">
                                                                                    <div className='form-group col-md-3'>
                                                                                        <label htmlFor={`documentType_${index}`} className='form-label'>
                                                                                            Document Type <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                        </label>
                                                                                        <select id={`documentType_${index}`} className="form-select" name='documentTypeId' value={doc.documentTypeId} onChange={(e) => handleOnboardingDocumentChange(index, e)}>
                                                                                            <option value="">--Select Document Type--</option>
                                                                                                {allDocumentTypes.map((prt) => (
                                                                                                    <option key={prt.documentTypeId} value={parseInt(prt.documentTypeId)}>{prt.documentTypeName}</option>
                                                                                                ))}
                                                                                        </select>
                                                                                    </div>
                                                                                    {doc.showOtherDocumentType && (
                                                                                    <div className='form-group col-md-4'>
                                                                                        <label htmlFor={`otherDocumentType_${index}`} className='form-label'>
                                                                                        Other Document Type <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                        </label>
                                                                                        <input type="text" id={`otherDocumentType_${index}`} className="form-control" name="otherDocumentType" value={doc.otherDocumentType} onChange={(e) => handleOnboardingDocumentChange(index, e)} />
                                                                                    </div>
                                                                                    )}
                                                                                    <div className='form-group col-md-3'>
                                                                                        <label htmlFor={`uploadFile_${index}`} className='form-label'>
                                                                                        Upload File <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                        </label>
                                                                                        <input type="file" className="form-control" name="file" onChange={(e) => handleOnboardingDocumentChange(index, e)} />
                                                                                    </div>                                        
                                                                                    <div className='form-group col-md-2' style={{marginTop: '30px'}}>
                                                                                        <button type="button" className='btn btn-primary me-2' onClick={addOnboardingDocumentRow}><i className="bi bi-plus-circle"></i></button>
                                                                                        {onboardingDocuments.length > 1 && (
                                                                                        <button type="button" className='btn btn-danger' onClick={() => removeOnboardingDocumentRow(index)}><i className="bi bi-dash-circle"></i></button>
                                                                                        )}
                                                                                    </div>                                    
                                                                                </div>                
                                                                            ))}
                                                                            {(userInfo.isAdmin || userHasApproveSBPRequest) && (
                                                                            <div className='row'>
                                                                                <div className='mb-2 col-md-12' style={{ textAlign: 'right' }}>
                                                                                    <button type="submit" id="btnUploadOnboardingDoc" className="btn btn-primary me-2" onClick={handleUploadOnboardingDoc}>Upload</button>
                                                                                </div>
                                                                            </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </fieldset>
                                                            </div>
                                                        </div>
                                                    ))
                                                )} 
                                                {uploadedOnboardingDocuments && uploadedOnboardingDocuments.length > 0 && (
                                                <div className='responseevents'>
                                                    <div className='section-header'>
                                                        <span>Uploaded Onboarding Documents</span>
                                                    </div>
                                                    <div className='form-outline'>
                                                        <fieldset>        
                                                            <>
                                                                {uploadedOnboardingDocuments.map((doc, index) => (
                                                                    doc.documentTypeName && doc.uploadedDocumentName && doc.uploadedDocumentPath && doc.uploadedDate && (
                                                                        <div key={index} className='row'>
                                                                            <div className="form-group col-md-3">
                                                                                <label className='form-label'>
                                                                                    <strong>Document Type: </strong>{doc.documentTypeName === "Others" ? doc.otherDocumentTypeName : doc.documentTypeName}
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-group col-md-5">
                                                                                <label className='form-label'>
                                                                                    <strong>Uploaded Document: </strong>{doc.uploadedDocumentName}
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-group col-md-3">
                                                                                <label className='form-label'>
                                                                                    <strong>Uploaded Date: </strong>{doc.uploadedDate !== null ? formatDate(doc.uploadedDate) : null}
                                                                                </label>
                                                                            </div>
                                                                            <div className='form-group col-md-1'>
                                                                                <button className='btn btn-sm' style={{ float: 'right' }} onClick={() => handleDownloadDocument(doc.uploadedDocumentName, doc.uploadedDocumentPath)}>
                                                                                    <i className="bi bi-download" style={{ color: '#0000ff' }}></i>
                                                                                </button>
                                                                            </div>
                                                                            {index !== uploadedOnboardingDocuments.length - 1 && <hr />}
                                                                        </div>                                                                        
                                                                    )
                                                                ))}                                                                
                                                                <div className='row'>
                                                                    <div className='mb-2 col-md-12' style={{ textAlign: 'right' }}>
                                                                        <button type="submit" id="btnNotifyOnboardingDoc" className="btn btn-primary me-2" onClick={handleNotifyOnboardingDoc}>Notify</button>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        </fieldset>
                                                    </div>
                                                </div>
                                                )}
                                                {uploadedOnboardingDocuments && uploadedOnboardingDocuments.length > 0 && (
                                                    <div className='responseevents'>
                                                        <div className='section-header'>
                                                            <span>Deployment Dates</span>
                                                        </div>
                                                        <div className='form-outline'>
                                                            <fieldset>
                                                                <div className='row'>
                                                                    {(!actualFromDateView && !actualToDateView) ? (
                                                                        <>
                                                                            <div className="form-group mb-2 col-md-3">
                                                                                <label htmlFor='actualFromDate' className='form-label'>
                                                                                    Actual From Date <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                </label>
                                                                                <DatePicker selected={actualFromDate} maxDate={actualToDate} onChange={(date) => handleInputChange(date, setActualFromDate, 'actualFromDate')} dateFormat="dd/MM/yyyy" placeholderText="Select from date" className='form-control'/>
                                                                                {errors.actualFromDate && <p style={{color: 'red'}}>{errors.actualFromDate}</p>}
                                                                            </div>
                                                                            <div className="form-group mb-2 col-md-3">
                                                                                <label htmlFor='actualToDate' className='form-label'>
                                                                                    Actual To Date <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                </label>
                                                                                <DatePicker selected={actualToDate} minDate={actualFromDate} onChange={(date) => handleInputChange(date, setActualToDate, 'actualToDate')} dateFormat="dd/MM/yyyy" placeholderText="Select to date" className='form-control'/>
                                                                                {errors.actualToDate && <p style={{color: 'red'}}>{errors.actualToDate}</p>}
                                                                            </div> 
                                                                            <div className="form-group mb-2 col-md-3">
                                                                                <label htmlFor="actualduration" className='form-label'>
                                                                                    Actual Duration <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                                                </label>
                                                                                <input type='text' className='form-control' readOnly value={actualFromDate && actualToDate ? `${calculateDaysInclusive(actualFromDate, actualToDate)} Days` : ''}></input>
                                                                            </div> 
                                                                            {(userInfo.isAdmin || userHasApproveSBPRequest) && (
                                                                            <div className='form-group col-md-3' style={{ textAlign: 'right', marginTop: '31px' }}>
                                                                                <button type="submit" id="btnUpdateDeploymentDates" className="btn btn-primary me-2" onClick={handleUpdateDeploymentDates}>
                                                                                    Update Deployment Dates
                                                                                </button>
                                                                            </div> 
                                                                            )}                                                                             
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <div className="form-group col-md-3">
                                                                                <label htmlFor='actualFromDateView' className='form-label me-2'>
                                                                                    <strong>Actual From Date:</strong> {actualFromDateView !== null ? formatDate(actualFromDateView) : null}
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-group col-md-3">
                                                                                <label htmlFor='actualToDateView' className='form-label me-2'>
                                                                                    <strong>Actual To Date:</strong> {actualToDateView !== null ? formatDate(actualToDateView) : null}
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-group col-md-3">
                                                                                <label htmlFor='requestedDuration' className='form-label'>
                                                                                    <strong>Requested Duration:</strong> {actualFromDateView && actualToDateView ? (<> {calculateDaysInclusive(actualFromDateView, actualToDateView)} <span>Days</span> </>):''}
                                                                                </label>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </fieldset>
                                                        </div>
                                                    </div> 
                                                )}
                                                {surveySentDate && (
                                                    <div className='responseevents'>
                                                        <div className='section-header'>
                                                            <span>Check-in Survey Details</span>
                                                        </div>
                                                        <div className='form-outline'>
                                                            <fieldset>
                                                                <div className='row'>
                                                                    <div className="form-group mb-2 col-md-3">
                                                                        <label htmlFor="surveySentDate" className="form-label">Survey Sent Date <span style={{color:"red", font:"bold"}}>*</span></label>
                                                                        <DatePicker selected={surveySentDate} dateFormat="dd/MM/yyyy" placeholderText="Select sent date" className='form-control' disabled/>
                                                                    </div>
                                                                    <div className="form-group mb-2 col-md-3">
                                                                        <label htmlFor="surveyStatus" className="form-label">Status <span style={{color:"red", font:"bold"}}>*</span></label>
                                                                        <select id="surveyStatus" className="form-select" value={parseInt(surveyStatus)} onChange={(e) => handleInputChange(e, setSurveyStatus, 'surveyStatus')} disabled = {parseInt(surveyStatusView)!== generalPendingStatusId}>
                                                                            <option value="">--Select--</option>
                                                                            {generalStatus.map((res) => (
                                                                            <option key={res.statusId} value={parseInt(res.statusId)}>{res.statusDescription}</option>
                                                                            ))}
                                                                        </select>
                                                                        {errors.surveyStatus && <p style={{color: 'red'}}>{errors.surveyStatus}</p>}
                                                                    </div>
                                                                    <div className="form-group mb-2 col-md-3">
                                                                        <label htmlFor="surveyCompleteDate" className="form-label">Survey Complete Date <span style={{color:"red", font:"bold"}}>*</span></label>
                                                                        <DatePicker selected={surveyCompleteDate} minDate={surveySentDate} onChange={(date) => handleInputChange(date, setSurveyCompleteDate, 'surveyCompleteDate')} dateFormat="dd/MM/yyyy" placeholderText="Select complete date" className='form-control' disabled = {parseInt(surveyStatusView)!== generalPendingStatusId}/>
                                                                        {errors.surveyCompleteDate && <p style={{color: 'red'}}>{errors.surveyCompleteDate}</p>}
                                                                    </div> 
                                                                    {parseInt(surveyStatusView) === generalPendingStatusId && (userInfo.isAdmin || userHasSendCheckinSurvey) && (
                                                                    <div className='form-group col-md-3' style={{ textAlign: 'right', marginTop: '31px' }}>
                                                                        <button type="submit" id="btnUpdateSurvey" className="btn btn-primary me-2" onClick={handleUpdateSurvey}>
                                                                            Update Check-in Survey
                                                                        </button>
                                                                    </div> 
                                                                    )}                                          
                                                                </div>
                                                            </fieldset>
                                                        </div>
                                                    </div>
                                                )}  
                                                {parseInt(perStatusView) === generalPendingStatusId && !uploadedPerDocumentName && !uploadedPerDocumentPath && (
                                                    <div className='responseevents'>
                                                        <div className='section-header'>
                                                            <span>Performace Evaluation</span>
                                                        </div>
                                                        <div className='form-outline'>
                                                            <fieldset>
                                                                <div className='row'>
                                                                    <div className="form-group mb-2 col-md-3">
                                                                        <label htmlFor="perDocument" className="form-label">PER Document <span style={{color:"red", font:"bold"}}>*</span></label>
                                                                        <input type="file" className="form-control" id='perDocument' onChange={(e) => handleInputChange(e, setPerDocument, 'perDocument')}/>
                                                                        {errors.perDocument && <p style={{color: 'red'}}>{errors.perDocument}</p>}                                                                            
                                                                    </div>
                                                                    <div className="form-group mb-2 col-md-3">
                                                                        <label htmlFor="perStatus" className="form-label">Status <span style={{color:"red", font:"bold"}}>*</span></label>
                                                                        <select id="perStatus" className="form-select" value={parseInt(perStatus)} onChange={(e) => handleInputChange(e, setPerStatus, 'perStatus')} disabled = {parseInt(perStatusView)=== completeStatusId}>
                                                                            <option value="">--Select--</option>
                                                                            {generalStatus.map((res) => (
                                                                            <option key={res.statusId} value={parseInt(res.statusId)}>{res.statusDescription}</option>
                                                                            ))}
                                                                        </select>
                                                                        {errors.perStatus && <p style={{color: 'red'}}>{errors.perStatus}</p>}
                                                                    </div>
                                                                    <div className="form-group mb-2 col-md-3">
                                                                        <label htmlFor="perUploadDate" className="form-label">Upload Date <span style={{color:"red", font:"bold"}}>*</span></label>
                                                                        <DatePicker selected={perUploadDate} minDate={surveyCompleteDate} onChange={(date) => handleInputChange(date, setPerUploadDate, 'perUploadDate')} dateFormat="dd/MM/yyyy" placeholderText="Select complete date" className='form-control' disabled = {parseInt(perStatusView)=== completeStatusId}/>
                                                                        {errors.perUploadDate && <p style={{color: 'red'}}>{errors.perUploadDate}</p>}
                                                                    </div> 
                                                                    {parseInt(perStatusView)!== completeStatusId && (userInfo.isAdmin || userHasSendPerformanceEvaluation) && (
                                                                        <div className='form-group col-md-3' style={{ textAlign: 'right', marginTop: '31px' }}>
                                                                            <button type="submit" id="btnUploadPerDocuments" className="btn btn-primary me-2" onClick={handleUploadPerDocument}>
                                                                                Upload PER Document
                                                                            </button>
                                                                        </div> 
                                                                    )}                                          
                                                                </div>
                                                            </fieldset>
                                                        </div>
                                                    </div>
                                                )} 
                                                {uploadedPerDocumentName && uploadedPerDocumentPath && (
                                                    <div className='responseevents'>
                                                        <div className='section-header'>
                                                            <span>Performace Evaluation</span>
                                                        </div>
                                                        <div className='form-outline'>
                                                            <fieldset>
                                                                <div className='row'>
                                                                    <div className="form-group mb-2 col-md-3">
                                                                        <label htmlFor="perDocument" className="form-label">PER Document <span style={{color:"red", font:"bold"}}>*</span></label>
                                                                        <input type="text" className="form-control" id="uploadedPerDocument" value={uploadedPerDocumentName} disabled/>                                                                        
                                                                    </div>
                                                                    <div className="form-group mb-2 col-md-3">
                                                                        <label htmlFor="perStatus" className="form-label">Status <span style={{color:"red", font:"bold"}}>*</span></label>
                                                                        <select id="perStatus" className="form-select" value={parseInt(perStatus)} onChange={(e) => handleInputChange(e, setPerStatus, 'perStatus')} disabled>
                                                                            <option value="">--Select--</option>
                                                                            {generalStatus.map((res) => (
                                                                            <option key={res.statusId} value={parseInt(res.statusId)}>{res.statusDescription}</option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div className="form-group mb-2 col-md-3">
                                                                        <label htmlFor="perUploadDate" className="form-label">Upload Date <span style={{color:"red", font:"bold"}}>*</span></label>
                                                                        <DatePicker selected={perUploadDate} onChange={(date) => handleInputChange(date, setPerUploadDate, 'perUploadDate')} dateFormat="dd/MM/yyyy" placeholderText="Select complete date" className='form-control' disabled/>
                                                                    </div> 
                                                                    <div className='form-group col-md-3'>
                                                                            <button className='btn btn-sm' style={{ float: 'right' }} onClick={() => handleDownloadDocument(uploadedPerDocumentName, uploadedPerDocumentPath)}>
                                                                                <i className="bi bi-download" style={{ color: '#0000ff' }}></i>
                                                                            </button>
                                                                    </div>                                      
                                                                </div>
                                                            </fieldset>
                                                        </div>
                                                    </div>
                                                )}  
                                                {rlaInvoiceNotificationSentDate && requestStatus === 'Completed SBP Deployment' && selectedSupportType === 'Supported on RLA' &&( 
                                                <div className='responseevents'>
                                                    <div className='section-header'>
                                                        <span>RLA Invoice Details</span>
                                                    </div>
                                                    <div className='form-outline'>
                                                        <fieldset>
                                                            {(userInfo.isAdmin || userHasRLACoordinator) && !rlaInvoiceDocumentName && !rlaInvoiceDocumentPath && !rlaInvoiceUploadDate && (
                                                            <div className='row'>
                                                                <div className='form-group col-md-6'>
                                                                    <label htmlFor='rlaInvoice' className='form-label'>Upload Invoice <span style={{ color: "red", fontWeight: "bold" }}>*</span></label>
                                                                    <input type="file" className="form-control" id='rlaInvoice' onChange={(e) => handleInputChange(e, setRlaInvoice, 'rlaInvoice')}/>
                                                                    {errors.rlaInvoice && <p style={{color: 'red'}}>{errors.rlaInvoice}</p>} 
                                                                </div> 
                                                                <div className='form-group col-md-6' style={{ textAlign: 'right' }}>
                                                                    <button type="submit" id="btnUploadRlaInvoice" className="btn btn-primary me-2" onClick={handleUploadRlaInvoice} style={{marginTop:'32px'}}>Upload Invoice</button>
                                                                </div>            
                                                            </div>
                                                            )}
                                                            {rlaInvoiceDocumentName && rlaInvoiceDocumentPath && rlaInvoiceUploadDate && (
                                                            <div className='row'>
                                                                <div className="form-group col-md-6">
                                                                    <label className='form-label'>
                                                                        <strong>Uploaded Invoice: </strong>{rlaInvoiceDocumentName}
                                                                    </label>
                                                                </div>
                                                                <div className="form-group col-md-4">
                                                                    <label className='form-label'>
                                                                        <strong>Uploaded Date: </strong>{rlaInvoiceUploadDate !== null ? formatDate(rlaInvoiceUploadDate) : null}
                                                                    </label>
                                                                </div>
                                                                <div className='form-group col-md-2'>
                                                                    <button className='btn btn-sm' style={{ float: 'right' }} onClick={() => handleDownloadDocument(rlaInvoiceDocumentName, rlaInvoiceDocumentPath)}>
                                                                        <i className="bi bi-download" style={{ color: '#0000ff' }}></i>
                                                                    </button>
                                                                </div>            
                                                            </div>
                                                            )}
                                                        </fieldset>
                                                    </div>
                                                </div>
                                                )}
                                                {rlaInvoiceDocumentName && rlaInvoiceDocumentPath && requestStatus === 'Completed SBP Deployment' && selectedSupportType === 'Supported on RLA' &&( 
                                                <div className='responseevents'>
                                                    <div className='section-header'>
                                                        <span>Proof of Payment</span>
                                                    </div>
                                                    <div className='form-outline'>
                                                        <fieldset>
                                                            {(userInfo.isAdmin || userHasReviewSBPRequest || userHasApproveSBPRequest) && !proofOfPaymentDocument && !proofOfPaymentDocumentPath && !proofOfPaymentUploadDate && (
                                                            <div className='row'>
                                                                <div className='form-group col-md-4'>
                                                                    <label htmlFor='proofOfPayment' className='form-label'>Upload Proof of Payment <span style={{ color: "red", fontWeight: "bold" }}>*</span></label>
                                                                    <input type="file" className="form-control" id='proofOfPayment' onChange={(e) => handleInputChange(e, setProofOfPayment, 'proofOfPayment')}/>
                                                                    {errors.proofOfPayment && <p style={{color: 'red'}}>{errors.proofOfPayment}</p>} 
                                                                </div> 
                                                                <div className='form-group col-md-6'>
                                                                    <label htmlFor='paymentRemark' className='form-label'>Remark <span style={{color:'red', fontWeight:'bold'}}>*</span></label>
                                                                    <input type='text' className='form-control' id='paymentRemark' onChange={(e) => handleInputChange(e, setPaymentRemark, 'paymentRemark')} />
                                                                    {errors.paymentRemark && <p style={{color:'red'}}>{errors.paymentRemark}</p>}
                                                                </div>
                                                                <div className='form-group col-md-2' style={{ textAlign: 'right' }}>
                                                                    <button type="submit" id="btnUploadProofOfPayment" className="btn btn-primary me-2" onClick={handleUploadProofOfPayment} style={{marginTop:'32px'}}>Upload</button>
                                                                </div>            
                                                            </div>
                                                            )}
                                                            {proofOfPaymentDocument && proofOfPaymentDocumentPath && proofOfPaymentUploadDate && (
                                                            <div className='row'>
                                                                <div className="form-group col-md-3">
                                                                    <label className='form-label'>
                                                                        <strong>Uploaded Proof: </strong>{proofOfPaymentDocument}
                                                                    </label>
                                                                </div>
                                                                <div className="form-group col-md-3">
                                                                    <label className='form-label'>
                                                                        <strong>Uploaded Date: </strong>{proofOfPaymentUploadDate !== null ? formatDate(proofOfPaymentUploadDate) : null}
                                                                    </label>
                                                                </div>
                                                                <div className="form-group col-md-5">
                                                                    <label className='form-label'>
                                                                        <strong>Remark: </strong>{paymentRemark}
                                                                    </label>
                                                                </div>                                                                
                                                                <div className='form-group col-md-1'>
                                                                    <button className='btn btn-sm' style={{ float: 'right' }} onClick={() => handleDownloadDocument(proofOfPaymentDocument, proofOfPaymentDocumentPath)}>
                                                                        <i className="bi bi-download" style={{ color: '#0000ff' }}></i>
                                                                    </button>
                                                                </div>            
                                                            </div>
                                                            )}
                                                        </fieldset>
                                                    </div>
                                                </div>
                                                )}                                                           
                                            </>)}
                                            {(userInfo.isAdmin || userHasApproveSBPRequest || userHasReviewSBPRequest || userHasComApprover || userHasSendToSBPAgencies || userHasSendCheckinSurvey || userHasUploadCvs || userHasSelectCandidate || userHasSendPerformanceEvaluation) &&(                                                                     
                                            <div className='row' style={{float:'right'}}>
                                                <div className="form-group mb-1 col-md-12">
                                                    {comHodApproveButtonVisibilityStatus.includes(requestStatus) && (userInfo.isAdmin || userHasComApprover) && (
                                                        <>
                                                            <button type="submit" id="btnComHodApprove" className="btn btn-primary me-2" onClick={handleComHodApprove}>Approve</button>
                                                            <button type="submit" id="btnComHodReject" className="btn btn-danger me-2" onClick={handleComHodReject}>Reject</button>
                                                        </>                                                    
                                                    )}
                                                    {approveButtonVisibilityStatus.includes(requestStatus) && (userInfo.isAdmin || userHasApproveSBPRequest) && (
                                                        <button type="submit" id="btnApprove" className="btn btn-primary me-2" onClick={handleApprove}>Launch</button>
                                                    )}
                                                    {sendSBPPartnersButtonVisibilityStatus.includes(requestStatus) && (userInfo.isAdmin || userHasSendToSBPAgencies) && !sbpPartnerName && (
                                                        <button type="submit" id="btnSendToSbpAgencies" className="btn btn-primary me-2" onClick={() => handleSendToSbpPartners('normal')}>Send To SBP Partners</button>
                                                    )}
                                                    {shouldShowUploadButton && (userInfo.isAdmin || userHasUploadCvs) && uploadCvButtonStatus.includes(requestStatus) && (
                                                        <button type="submit" id="btnUploadCv" className="btn btn-primary me-2" onClick={handleUploadCandidateCvs}>Upload CVs</button>
                                                    )}
                                                    {(userInfo.isAdmin || hasValidCVs) && !selectedCandidateName && !candidateEmailId && !selectedDate && selectCandidateButtonVisibilityStatus.includes(requestStatus) && userHasSelectCandidate &&(
                                                        <button type="submit" id="btnSelectCandidate" className="btn btn-primary me-2" onClick={handleSelectCandidate}>Select Candidate</button>
                                                    )}
                                                    {surveySentDate === null && (userInfo.isAdmin || userHasSendCheckinSurvey) && actualFromDateView && new Date() >= checkinSurveyVisibilityDate && (
                                                        <button type="submit" id="btnSendCheckInSurvey" className="btn btn-primary me-2" onClick={handleSendCheckinSurvey}>Send Check-in Survey To Selected Candidate</button>
                                                    )}
                                                    {!perStatus && (userInfo.isAdmin || userHasSendPerformanceEvaluation) && actualToDateView && new Date() <= performanceEvaluationVisibilityDate && (
                                                        <button type="submit" id="btnPerformanceEvaluation" className="btn btn-primary me-2" onClick={handlePerformanceEvaluation}>Performance Evaluation</button>
                                                    )}
                                                    {(userInfo.isAdmin || userHasRLACoordinator) && !rlaInvoiceNotificationSentDate && requestStatus === 'Completed SBP Deployment' && selectedSupportType === 'Supported on RLA' && new Date() >= rlaInvoiceVisibilityDate (                                                    
                                                        <button type="submit" id="btnRlaInvoice" className="btn btn-primary me-2" onClick={handleRequestRLAInvoice}>Notify SBP Partners for RLA Invoice</button>
                                                    )}
                                                    {rejectButtonVisibilityStatus.includes(requestStatus) && (userInfo.isAdmin || userHasApproveSBPRequest || userHasReviewSBPRequest) && (
                                                        <button type="submit" id="btnReject" className="btn btn-danger me-2" onClick={handleReject}>Reject</button>
                                                    )}
                                                    {requestStatus === 'Rejected' && (userInfo.isAdmin || userHasApproveSBPRequest || userHasReviewSBPRequest) && (
                                                        <button type="submit" id="btnReopen" className="btn btn-primary me-2" onClick={handleReopen}>Re Open</button>
                                                    )}
                                                    {revertButtonVisibilityStatus.includes(requestStatus) && (userInfo.isAdmin || userHasApproveSBPRequest || userHasReviewSBPRequest) && (
                                                        <button type="submit" id="btnRevert" className="btn btn-secondary me-2" onClick={handleRevert}>Revert</button>
                                                    )}         
                                                    {requestStatus === 'Reverted' && (
                                                        <>
                                                            <button type="submit" id="btnEdit" className="btn btn-secondary me-2" onClick={handleReopen}>Edit</button>
                                                            <button type="submit" id="btnReSubmit" className="btn btn-primary me-2" onClick={handleReSubmit}>Re Submit</button>
                                                        </>
                                                    )}                                                                                           
                                                </div>
                                            </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                {showHistory && (
                                    <div className='card mb-3'>
                                        <div className='card-header'>
                                            <strong>Request Code :</strong> {requestCode } | <strong>Current Status :</strong> <span style={{color: requestStatus === 'Submitted for COM/HOD Approval' ? 'blue' : requestStatus === 'Submitted' ? 'blue' : requestStatus === 'Launched' ? 'green' : requestStatus === 'SBP Partner Coordination' ? 'green' : requestStatus === 'Candidate Selection' ? 'green' : requestStatus === 'Candidate Selected' ? 'green' : requestStatus === 'Submitted for Approval' ? 'green' : requestStatus === 'Ongoing Deployment' ? 'green' : requestStatus === 'Rejected' ? 'red' : requestStatus === 'Reverted' ? 'orange' : requestStatus === 'In Progress' ? 'green' : requestStatus === 'Completed SBP Deployment' ? '#0033A0' : 'black', fontWeight:'bold'}}>{requestStatus}</span>
                                            <button className="btn" style={{float:'right', color:'#265aeda6', fontWeight: 'bold'}} onClick={handleShowRemarks}>Remarks</button>
                                            <button className="btn" style={{float:'right', color:'#265aeda6', fontWeight: 'bold'}} onClick={handleBackToDetails}>Request Details</button>
                                        </div>
                                        <div className='card-body'>
                                            <div className='responseevents'>
                                                <div className='section-header'>
                                                    <span>
                                                        Request Histories
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="table-responsive" style={{fontSize:"0.9rem"}}>
                                            {historyData && historyData.length > 0 ? (
                                                <table className="table table-bordered table-striped">
                                                    <thead className='thead-light' style={{background:"ghostwhite"}}>
                                                        <tr>
                                                            <th style={{width:'10%', background:"#7a9fd9", textAlign: 'center', verticalAlign: 'middle'}}>User Name</th>
                                                            <th style={{width:'20%', background:"#7a9fd9", textAlign: 'center', verticalAlign: 'middle'}}>Action Date</th>
                                                            <th style={{width:'70%', background:"#7a9fd9", textAlign: 'center', verticalAlign: 'middle'}}>Action Performed</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {historyData.length > 0 ? ( historyData.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.createdBy}</td>                                                                
                                                            <td>{formatDateToUTC(item.actionDate)}</td>   
                                                            <td>{item.actionDescription}</td>                                                             
                                                        </tr>
                                                    ))) : (
                                                            <tr>
                                                                <td colSpan="4" className="text-center">No history available.</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                ) : (
                                                <p>No history available.</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                )}
                                {showRemarks && (
                                        <div className='card mb-3'>
                                            <div className='card-header'>
                                                <strong>Request Code :</strong> {requestCode } | <strong>Current Status :</strong> <span style={{color: requestStatus === 'Submitted for COM/HOD Approval' ? 'blue' : requestStatus === 'Submitted' ? 'blue' : requestStatus === 'Launched' ? 'green' : requestStatus === 'SBP Partner Coordination' ? 'green' : requestStatus === 'Candidate Selection' ? 'green' : requestStatus === 'Candidate Selected' ? 'green' : requestStatus === 'Submitted for Approval' ? 'green' : requestStatus === 'Ongoing Deployment' ? 'green' : requestStatus === 'Rejected' ? 'red' : requestStatus === 'Reverted' ? 'orange' : requestStatus === 'In Progress' ? 'green' : requestStatus === 'Completed SBP Deployment' ? '#0033A0' : 'black', fontWeight:'bold'}}>{requestStatus}</span>
                                                <button className="btn" style={{float:'right', color:'#265aeda6', fontWeight: 'bold'}} onClick={handleShowHistory}>History</button>
                                                <button className="btn" style={{float:'right', color:'#265aeda6', fontWeight: 'bold'}} onClick={handleBackToDetails}>Request Details</button>
                                            </div>
                                            <div className='card-body'>
                                                <div className='responseevents'>
                                                    <div className='section-header'>
                                                        <span>
                                                        Request Remarks
                                                        </span>
                                                        <button className="btn" style={{float:'right', color:'white'}} onClick={handleAddRemarkModel}>Add Remark</button>
                                                    </div>
                                                </div>
                                                <div className="table-responsive" style={{fontSize:"0.9rem"}}>
                                                    {remarksData && remarksData.length > 0 ? (
                                                        <table className="table table-bordered table-striped">
                                                            <thead className='thead-light' style={{background:"ghostwhite"}}>
                                                                <tr>
                                                                    <th style={{width:'10%', background:"#7a9fd9", textAlign: 'center', verticalAlign: 'middle'}}>User Name</th>                                                                                                            
                                                                    <th style={{width:'20%', background:"#7a9fd9", textAlign: 'center', verticalAlign: 'middle'}}>Remark Date</th>
                                                                    <th style={{width:'70%', background:"#7a9fd9", textAlign: 'center', verticalAlign: 'middle'}}>Remark</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {remarksData.length > 0 ? (
                                                                remarksData.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>{item.createdBy}</td>
                                                                        <td>{formatDateToUTC(item.remarkDate)}</td>
                                                                        <td>{item.remark}</td>                                                                    
                                                                    </tr>
                                                                ))
                                                                ) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center">No Remarks available.</td>
                                                                </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    ) : (
                                                        <p>No Remarks available.</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                )}  
                            </div>
                            <Modal show={showPopup} onHide={handleClosePopup} className='positions-modal'>
                                <Modal.Header closeButton>
                                    <Modal.Title>Details for Position: {deploymentRequestPosition}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="text-start">
                                        {uploadedDocumentName && torDocumentPath && (
                                        <>
                                            <div className='section-header' style={{marginBottom:'3px', marginLeft:'-5px', fontWeight:'bold'}}>Terms of Reference</div>
                                            <div className="form-group mb-3">
                                                <strong>Uploaded Documents: </strong> 
                                                <a style={{textDecoration:'auto'}}>{uploadedDocumentName}</a>
                                                <button className='btn btn-sm me-4' style={{float:'right'}} onClick={() => handleDownloadDocument(uploadedDocumentName, torDocumentPath)}><i class="bi bi-download" style={{color:'#0000ff'}}></i></button>
                                            </div>
                                        </>
                                        )}                                        
                                        <div className='section-header' style={{marginBottom:'3px', marginLeft:'-5px', fontWeight:'bold'}}>Request Justification</div>
                                        <div className="form-group mb-2">
                                            <strong>Please explain why the post is urgent and why current IOM capacity cannot meet this need (or if requesting an extension, why one is needed)?: </strong>{urgentRequestJustification}
                                        </div>
                                        <div className="form-group mb-2">
                                            <strong>What are 3-4 critical deliverables of this post?: </strong>{criticalRequestJustification}
                                        </div>
                                        <div className="form-group mb-3">
                                            <strong>What is the longer-term staffing plan after SBP temporary support period/handover strategy (where relevant)?: </strong>{longerTermRequestJustification}
                                        </div>
                                        <div className='section-header' style={{marginBottom:'3px', marginLeft:'-5px', fontWeight:'bold'}}>Security & Administrative</div>
                                        <div className='form-group mb-2'>
                                            <strong>UN Security Phase in-country/duty station: </strong>{unSecurityPhaseDutyStation}
                                        </div>
                                        <div className='form-group mb-2'>
                                            <strong>Special Medical Requirements (vaccinations etc): </strong>{specialMedicalRequirements}
                                        </div>
                                        <div className='form-group mb-2'>
                                            <strong>Visa Requirement (e.g., visa on arrival, invitation letter, etc): </strong>{visaRequirements}
                                        </div>
                                        <div className='form-group mb-2'>
                                            <strong>R & R cycle at duty station: </strong>{rrCycle}
                                        </div>
                                        <div className='form-group mb-3'>
                                            <strong>Will office space and working tools be provided?: </strong>{isOfficeSpaceProvided === true ? 'Yes' : 'No'}
                                        </div>
                                        <div className='section-header' style={{marginBottom:'3px', marginLeft:'-5px', fontWeight:'bold'}}>Direct Supervisor of Deployee</div>
                                        <div className="form-group mb-2">
                                            <strong>Name:</strong> {supervisorName}
                                        </div>
                                        <div className="form-group mb-2">
                                            <strong>Position Title:</strong> {supervisorPosition}
                                        </div>
                                        <div className="form-group mb-3">
                                            <strong>Email:</strong> {supervisorEmail}
                                        </div>
                                        <div className='section-header' style={{marginBottom:'3px', marginLeft:'-5px', fontWeight:'bold'}}>Focal Point for Practical Arrangements related to deployment (Security Clearance, Pick-up at Airport, Booking of Hotel, Briefing, etc)</div>
                                        <div className="form-group mb-2">
                                            <strong>Name:</strong> {practicalArrangementSupervisorName}
                                        </div>
                                        <div className="form-group mb-2">
                                            <strong>Position Title:</strong> {practicalArrangementSupervisorPosition}
                                        </div>
                                        <div className="form-group mb-3">
                                            <strong>Email:</strong> {practicalArrangementSupervisorEmail}
                                        </div>
                                        <div className='section-header' style={{marginBottom:'3px', marginLeft:'-5px', fontWeight:'bold'}}>Focal point for the Performance Evaluation</div>
                                        <div className="form-group mb-2">
                                            <strong>Name:</strong> {performanceEvaluationSupervisorName}
                                        </div>
                                        <div className="form-group mb-2">
                                            <strong>Position Title:</strong> {performanceEvaluationSupervisorPosition}
                                        </div>
                                        <div className="form-group mb-3">
                                            <strong>Email:</strong> {performanceEvaluationSupervisorEmail}
                                        </div>
                                        {uploadedProofOfApprovalDocumentName && proofOfApprovalDocumentPath && (
                                        <>
                                            <div className='section-header' style={{marginBottom:'3px', marginLeft:'-5px', fontWeight:'bold'}}>Proof of Approval from COM/HOD</div>
                                            <div className="form-group">
                                                <strong>Uploaded Documents: </strong> 
                                                <a style={{textDecoration:'auto'}}>{uploadedProofOfApprovalDocumentName}</a>
                                                <button className='btn btn-sm me-4' style={{float:'right'}} onClick={() => handleDownloadDocument(uploadedProofOfApprovalDocumentName, proofOfApprovalDocumentPath)}><i class="bi bi-download" style={{color:'#0000ff'}}></i></button>
                                            </div>
                                        </>
                                        )}
                                    </div>
                                </Modal.Body>
                            </Modal>
                            <Modal show={show} onHide={handleClose} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title className="text-center w-100">{modalTitle}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="modal-body-scrollable">
                                    <p>{modalBody}</p>
                                    {(buttonText !== 'Approve' && buttonText !== 'Launch' && buttonText !== "Submit for Approval" && buttonText !== "Save" && buttonText !== "Update" && buttonText !== "Send" && buttonText !== "Send To Requester" && buttonText !== 'Approve RLA' && buttonText !== 'Update Deployment Dates' && buttonText !== 'Send Check-in Survey' && buttonText !== 'Performance Evaluation' && buttonText !== 'Update Check-in Survey' && buttonText !== 'Upload PER Document' && buttonText !== 'Notify SBP Partner' && buttonText !== 'Upload Invoice' && buttonText !== 'Upload Proof of Payment') && (
                                        <textarea className="form-control" rows="3" value={reason} onChange={handleReasonChange} placeholder="Enter your reason here..."></textarea>
                                    )}
                                    {buttonText === 'Send Check-in Survey' && (
                                    <>
                                        <label htmlFor="surveyApplicable" className="form-label" style={{float:'left', fontWeight:'bold'}}>Survey Applicable <span style={{color:"red", font:"bold"}}>*</span></label>    
                                        <select id="surveyApplicable" className="form-select" value={parseInt(surveyApplicable)} onChange={(e) => handleInputChange(e, setSurveyApplicable, 'surveyApplicable')}>
                                            <option value="">--Select Survey Applicable--</option>
                                            {generalStatus.filter(res => res.statusDescription === "Applicable" || res.statusDescription === "Not Applicable").map((res) => (
                                            <option key={res.statusId} value={parseInt(res.statusId)}>{res.statusDescription}</option>
                                            ))}
                                        </select>
                                    </>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <button type='button' className="btn btn-secondary me-2" onClick={handleClose}>Cancel</button>
                                    <button type='button' className="btn btn-primary" onClick={handleModalConfirm} disabled = {actionDisabled}>
                                        {buttonText}
                                    </button>
                                    {loading && (
                                        <div className="w-100 text-center mt-2">
                                            <p style={{fontWeight:'bold'}}>Processing your request, please wait...</p>
                                        </div>
                                    )}
                                </Modal.Footer>
                            </Modal>
                            <Modal show={showRemarkModal} onHide={handleCloseRemarkModal} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title className="text-center w-100">Add Remark</Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="modal-body-scrollable">
                                    <textarea className="form-control" rows="3" value={remarkPopupText} onChange={handleRemarkPopupText} placeholder="Enter remark here..."></textarea>
                                    {remarkError && (
                                        <div className="text-danger mt-2">
                                            {remarkError}
                                        </div>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <button type='button' className="btn btn-primary" onClick={handleModalConfirmRemark}>Save</button>
                                </Modal.Footer>
                            </Modal>
                            <Modal show={showSbpPartnersModal} onHide={handleCloseSbpPartnersModal} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title className="text-center w-100">Select SBP Partners</Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="modal-body-scrollable">
                                    <div className="form-check" style={{ textAlign: 'left' }}>
                                        <input className="form-check-input" type="checkbox" id="select-all-partners" checked={ sbpPartnersList.length > 0 && selectedPartners.filter((id) => !existingPartnersId.includes(id)).length === sbpPartnersList.filter((partner) => !existingPartnersId.includes(partner.sbpId)).length } onChange={handleSelectAllPartners} />
                                        <label className="form-check-label" htmlFor="select-all-partners" style={{ fontWeight: 'bold' }} >
                                            Select All
                                        </label>
                                    </div>
                                    {sbpPartnersList.map((partner, index) => (
                                    <div key={index} className="form-check" style={{ textAlign: 'left' }}>
                                        <input className="form-check-input" type="checkbox" id={`partner-${index}`}
                                        checked={selectedPartners.includes(partner.sbpId) || existingPartnersId.includes(partner.sbpId)}
                                        onChange={() => handlePartnerSelection(partner.sbpId)}
                                        disabled={existingPartnersId.includes(partner.sbpId)} />
                                        <label className="form-check-label" htmlFor={`partner-${index}`}>
                                        {partner.sbpName}
                                        </label>
                                    </div>
                                    ))}
                                </Modal.Body>
                                <Modal.Footer>
                                    <button type="button" className="btn btn-primary" onClick={handleOpenConfirmationModal}>
                                    {existingPartnersId.length > 0 ? 'Resend Email' : 'Send Email'}
                                    </button>
                                </Modal.Footer>
                            </Modal>
                            {showConfirmationModal && (
                            <Modal show={showConfirmationModal} onHide={handleCloseConfirmationModal} centered style={{position:'absolute'}}>
                                <Modal.Header>
                                    <Modal.Title className="text-center w-100">
                                        {selectedPartners.length === 0 ? <span style={{color:'red'}}>Failed!</span> : 'Confirm Action'}
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {selectedPartners.length === 0
                                        ? <span style={{color:'red'}}>Please select at least one SBP partner before sending the email.</span>
                                        : 'Are you sure you want to send the email to the selected SBP partners?'}
                                </Modal.Body>
                                <Modal.Footer>
                                    <button type="button" className="btn btn-secondary" onClick={handleCloseConfirmationModal}>{selectedPartners.length === 0 ? 'Ok' : 'Cancel'}</button>
                                    {selectedPartners.length > 0 && (
                                        <button type="button" className="btn btn-primary" onClick={handleSendEmailConfirmed}>Yes, Send Email</button>
                                    )}
                                </Modal.Footer>
                            </Modal>
                            )}
                            <Modal show={showSbpPartnersNameModal} onHide={handleCloseSbpPartnersNameModal} className='positions-modal'>
                                <Modal.Header closeButton>
                                    <Modal.Title className="text-center w-100">
                                        SBP Partners for the Request
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="table-responsive" style={{fontSize:"0.9rem"}}>
                                        <table className="table table-bordered table-striped">
                                            <thead className="thead-light" style={{background:"ghostwhite"}}>
                                                <tr>
                                                    <th style={{background:"#7a9fd9", width:'25%', textAlign: 'center', verticalAlign: 'middle'}}>Partner Name</th>
                                                    <th style={{background:"#7a9fd9", width:'10%', textAlign: 'center', verticalAlign: 'middle'}}>Status</th>
                                                    <th style={{background:"#7a9fd9", width:'10%', textAlign: 'center', verticalAlign: 'middle'}}>Date</th>
                                                    <th style={{background:"#7a9fd9", width:'50%', textAlign: 'center', verticalAlign: 'middle'}}>Reason</th>
                                                    <th style={{background:"#7a9fd9", width:'5%', textAlign: 'center', verticalAlign: 'middle'}}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {sbpPartnersDetails.map((partner) => (
                                                <tr key={partner.sbpPartnerId}>
                                                    <td>{partner.sbpPartnerName}</td>
                                                    <td>{partner.sbpPartnerStatus}</td>
                                                    <td>{partner.createdDate !== null ? formatDate(partner.createdDate) : null}</td>
                                                    <td>{partner.rejectedReason}</td>
                                                    <td style={{textAlign: 'center'}}>
                                                        <button className="btn btn-default btn-sm" onClick={() => handleUpdatePartnerDetailsClick(partner)}>
                                                        <span className='bi bi-pencil' style={{color:'#ffc107'}}/>
                                                        </button>
                                                    </td>
                                                </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </Modal.Body>
                            </Modal>
                            <Modal show={showUpdateModal} onHide={handleCloseUpdateModal}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Update Partner Details</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {selectedPartnerEdit && (
                                        <>
                                            <div className="form-group mb-3">
                                                <label htmlFor="sbpPartnerName" className="form-label" style={{textAlign:'left', fontWeight:'bold', display:'block'}}>Partner Name <span style={{ color: "red", font: "bold" }}>*</span></label>
                                                <input type="text" className="form-control" id="sbpPartnerName" name="sbpPartnerName" value={selectedPartnerEdit.sbpPartnerName} disabled />
                                            </div>
                                            <div className="form-group mb-3">
                                                <label htmlFor="sbpPartnerStatus" className="form-label" style={{textAlign:'left', fontWeight:'bold', display:'block'}}>Status <span style={{ color: "red", font: "bold" }}>*</span></label>
                                                <select id='sbpPartnerStatus' name="partnerStatusId" className="form-select" value={selectedPartnerEdit.partnerStatusId || ''} onChange={(e) => handlePartnerChange(e.target.name, e.target.value)}>
                                                    <option value={''}>--Select--</option>
                                                    {sbpPartnerSupportStatus.map((status) => (
                                                        <option key={status.partnerStatusId} value={status.partnerStatusId}>
                                                            {status.statusDescription}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className='form-group mb-3'> 
                                                <label htmlFor='partnerUpdatedDate' className='form-label' style={{textAlign:'left', fontWeight:'bold', display:'block'}}>Date <span style={{ color: "red", font: "bold" }}>*</span></label>
                                                <DatePicker selected={selectedPartnerEdit.createdDate} onChange={(date) => handlePartnerChange('createdDate', date)} dateFormat="dd/MM/yyyy" placeholderText="Select Update date" className='form-control' />
                                            </div>
                                            {parseInt(selectedPartnerEdit.partnerStatusId) === sbpRejectedStatusId && (
                                            <div className="form-group mb-3">
                                                <label htmlFor="rejectedReason" className="form-label" style={{textAlign:'left', fontWeight:'bold', display:'block'}}>Reason <span style={{ color: "red", font: "bold" }}>*</span></label>
                                                <textarea className="form-control" id="rejectedReason" name="rejectedReason" value={selectedPartnerEdit.rejectedReason} onChange={(e) => handlePartnerChange(e.target.name, e.target.value)} />
                                            </div>
                                            )}   
                                            {sbpPartnerUpdateValidation && (
                                            <div className='form-group mb-3'>    
                                                <span style={{color:'red', textAlign:'left', fontWeight:'bold', display:'block'}}>Please fill the required fields before update the Partner Details</span>
                                            </div>
                                                )}                                         
                                            <button type="submit" className="btn btn-primary" onClick={handleUpdateSbpDetails}>Update</button>
                                        </>
                                    )}
                                </Modal.Body>
                            </Modal>
                            <Modal show={showUploadCvModal} onHide={handleCloseUploadCvModal} className='uploadCv-modal'>
                                <Modal.Header>
                                    <Modal.Title>Upload CV of Candidates</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                {candidates.map((candidate, index) => (
                                    <div key={index} className="row mb-2">
                                        <div className='form-group col-md-3'>
                                            <select id={`partnerName_${index}`} className="form-select" name='sbpPartnerId' value={candidate.sbpPartnerId} onChange={(e) => handleUploadCvInputChange(index, e)}>
                                                <option value="">--Select Partner--</option>
                                                    {allSupportedSbpPartners.map((prt) => (
                                                        <option key={prt.sbpPartnerId} value={parseInt(prt.sbpPartnerId)}>{prt.sbpPartnerName}</option>
                                                    ))}
                                            </select>
                                        </div>
                                        <div className='form-group col-md-2'>
                                            <input type="text" id={`supportType_${index}`} className="form-control" name="supportType" value={candidate.supportType} onChange={(e) => handleUploadCvInputChange(index, e)} placeholder="Support Type" disabled />
                                        </div>
                                        <div className='form-group col-md-3'>
                                            <input type="text" className="form-control" name="candidateName" value={candidate.candidateName} onChange={(e) => handleUploadCvInputChange(index, e)} placeholder="Candidate Name" />
                                        </div>
                                        <div className='form-group col-md-3'>
                                            <input type="file" className="form-control" name="file" onChange={(e) => handleUploadCvInputChange(index, e)} />
                                        </div>                                        
                                        <div className='form-group col-md-1'>
                                            <button type="button" className='btn btn-primary me-2' onClick={addRow}><i className="bi bi-plus-circle"></i></button>
                                            {candidates.length > 1 && (
                                            <button type="button" className='btn btn-danger' onClick={() => removeRow(index)}><i className="bi bi-dash-circle"></i></button>
                                            )}
                                        </div>                                    
                                  </div>                
                                ))}   
                                {uploadCvError && (
                                    <span style={{ color: 'red', float: 'left', fontWeight: 'bold' }}>
                                        {uploadCvError.split("\n").map((error, idx) => (
                                            <React.Fragment key={idx}>
                                                {error}
                                                <br />
                                            </React.Fragment>
                                        ))}
                                    </span>
                                )}                                                                                                      
                                </Modal.Body>
                                <Modal.Footer>
                                    <button type='button' className="btn btn-secondary me-2" onClick={handleCloseUploadCvModal}>Cancel</button>
                                    <button type='button' className="btn btn-primary" onClick={uploadCandidateCvsDeploymentRequest}>Upload</button>
                                </Modal.Footer>
                            </Modal>
                            <Modal show={showSelectCandidateModal} onHide={handleCloseSelectCandidateModal} className='uploadCv-modal'>
                                <Modal.Header>
                                    <Modal.Title>Select Uploaded Candidate</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="row">
                                        <div className='form-group col-md-6'>
                                            <select id="selectedCandidateId" className="form-select" value={selectedCandidateId} onChange={(e) => handleInputChange(e, setSelectedCandidateId, 'selectedCandidateId')}>
                                                <option value="">--Select Candidate--</option>
                                                    {allUploadedCandidates.map((cand) => (
                                                        <option key={cand.candidateCvId} value={parseInt(cand.candidateCvId)}>{cand.candidateName}</option>
                                                    ))}
                                            </select>
                                        </div>
                                        <div className='form-group col-md-6'>
                                            <input type="text" className="form-control" id="candidateEmailId" placeholder="Candidate Email" value={candidateEmailId} onChange={(e) => handleInputChange(e, setCandidateEmailId, 'candidateEmailId')}/>
                                        </div>                                    
                                  </div> 
                                {selectCandidateError && (
                                    <span style={{ color: 'red', float: 'left', fontWeight: 'bold' }}>
                                        {selectCandidateError.split("\n").map((error, idx) => (
                                            <React.Fragment key={idx}>
                                                {error}
                                                <br />
                                            </React.Fragment>
                                        ))}
                                    </span>
                                )}                                                                                                      
                                </Modal.Body>
                                <Modal.Footer>
                                    <button type='button' className="btn btn-secondary me-2" onClick={handleCloseSelectCandidateModal}>Cancel</button>
                                    <button type='button' className="btn btn-primary" onClick={updateSelectedCandidateSbpRequest}>Update</button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default ViewSbpDeploymentRequest;
